<template>
  <div>
    <div class="ou-donation-form" :class="{ 'fullwidth': inHonorOf }">
      <div class="holder">
        <!-- <h2 class="h2__mixed">
            <span>Support</span> {{ form.applications && form.applications[0] && form.applications[0].department === 'NCSY_Tristate' ? '4G' : 'the NCSY' }}
            
        </h2> -->
        <PaymentForm class="form-horizontal">
                  <!-- <pre v-if="isDev" class="form-debug">{{ form }}</pre> -->
          <div ref="stepsBar" class="steps-bar">
            <div
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                'steps-bar__item--last': index >= steps.length - 1,
                'steps-bar__item--active': currentStep >= index + 1,
                'steps-bar__item--current-active': currentStep === index + 1,
              }"
              class="steps-bar__item"
            >
                <div class="steps-bar__item__text">
                  <svg  class="steps-bar__svg" v-if="(currentStep >= index + 1) && ( currentStep !== index + 1)" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33301 10.2612L8.04705 14.9753L17.4751 5.54719" stroke="#9ABBFF" stroke-width="1.3" stroke-linecap="round"/></svg>
                </div>
              <div class="steps-bar__item-dot"><span></span></div>
              <!--  -->
              <div class="steps-bar__item-line"></div>

            </div>
          </div>

          <div v-if="currentStep === 1" class="step">
            <section>
              <label class="label__tight">Donation Frequency</label>
              <div class="donatem__section">
              <div class="donatem__right">
                                <div class="multiple__payoptions">
                <NcsyGeneralPaymentsOptions addMonthly  monthesSelector/>
              </div>
              <div class="donateion__list">
                <NcsyGeneralAmounts />
                <ErrorLabel field="amount" />
              </div>


              <label class="label__tight">Choose your Designation</label>

              <div class="designation__info" id="designation">
                  <div class="designations__collect--three">   
                    <div class="designations-grid designations-grid--three">
                    <label 
                      v-for="designation in designationCards" 
                      :key="designation.value"
                      class="designation-card"
                    >
                      <input 
                        type="radio" 
                        :value="designation.value"
                        :checked="getValue('custom.designation') === designation.value"
                        @change="setValue('custom.designation', designation.value)"
                      />
                      <div class="designation-card__content">
                        <span class="designation-card__icon" v-html="designation.icon"></span>
                        <span class="designation-card__label">{{ designation.label }}</span>
                      </div>
                    </label>


                  </div>

                  <div class="designations-grid" v-if="false">
                    <label class="designation-card">
                      <input
                        type="radio"
                        :value="'General Donation'"
                        :checked="getValue('custom.designation') === 'General Donation'"
                        @change="setValue('custom.designation', 'General Donation')"
                      />
                      <div class="designation-card__content designgen">
                        <span></span>
                        <span class="designation-card__icon">
                      <svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17.7777 0C15.8871 0 14.2718 1.11241 13.4743 2.67875C12.8145 2.34646 12.0994 2.11492 11.3131 2.11492C8.6545 2.11492 6.46462 4.2642 6.46462 6.87347V14.3996C6.46159 14.6098 6.50115 14.8185 6.58101 15.0135C6.66087 15.2086 6.77944 15.3861 6.92981 15.5358C7.08018 15.6855 7.25937 15.8043 7.45696 15.8855C7.65454 15.9666 7.86659 16.0084 8.08077 16.0084C8.29495 16.0084 8.507 15.9666 8.70458 15.8855C8.90217 15.8043 9.08136 15.6855 9.23173 15.5358C9.38211 15.3861 9.50067 15.2086 9.58053 15.0135C9.66039 14.8185 9.69995 14.6098 9.69692 14.3996V6.87347C9.69692 5.97834 10.401 5.28729 11.3131 5.28729C12.2251 5.28729 12.9292 5.97834 12.9292 6.87347V20.6204C12.9262 20.8306 12.9658 21.0393 13.0456 21.2343C13.1255 21.4294 13.2441 21.6069 13.3944 21.7566C13.5448 21.9063 13.724 22.0252 13.9216 22.1063C14.1192 22.1874 14.3312 22.2292 14.5454 22.2292C14.7596 22.2292 14.9716 22.1874 15.1692 22.1063C15.3668 22.0252 15.546 21.9063 15.6963 21.7566C15.8467 21.6069 15.9653 21.4294 16.0451 21.2343C16.125 21.0393 16.1646 20.8306 16.1615 20.6204V4.75856C16.1615 3.86342 16.8656 3.17237 17.7777 3.17237C18.6897 3.17237 19.3938 3.86342 19.3938 4.75856V20.6204C19.3908 20.8306 19.4304 21.0393 19.5102 21.2343C19.5901 21.4294 19.7087 21.6069 19.859 21.7566C20.0094 21.9063 20.1886 22.0252 20.3862 22.1063C20.5838 22.1874 20.7958 22.2292 21.01 22.2292C21.2242 22.2292 21.4362 22.1874 21.6338 22.1063C21.8314 22.0252 22.0106 21.9063 22.161 21.7566C22.3113 21.6069 22.4299 21.4294 22.5098 21.2343C22.5896 21.0393 22.6292 20.8306 22.6262 20.6204V6.87347C22.6262 5.97834 23.3303 5.28729 24.2423 5.28729C25.1544 5.28729 25.8585 5.97834 25.8585 6.87347V19.563C25.8554 19.7732 25.895 19.9818 25.9749 20.1769C26.0547 20.3719 26.1733 20.5495 26.3237 20.6992C26.474 20.8488 26.6532 20.9677 26.8508 21.0488C27.0484 21.13 27.2604 21.1717 27.4746 21.1717C27.6888 21.1717 27.9008 21.13 28.0984 21.0488C28.296 20.9677 28.4752 20.8488 28.6256 20.6992C28.776 20.5495 28.8945 20.3719 28.9744 20.1769C29.0542 19.9818 29.0938 19.7732 29.0908 19.563V11.1033C29.0908 10.2082 29.7949 9.51712 30.7069 9.51712C31.619 9.51712 32.3231 10.2082 32.3231 11.1033V22.8365C32.3201 23.0467 32.3596 23.2554 32.4395 23.4505C32.5193 23.6455 32.6379 23.823 32.7883 23.9727C32.9386 24.1224 33.1178 24.2413 33.3154 24.3224C33.513 24.4035 33.7251 24.4453 33.9392 24.4453C34.1534 24.4453 34.3655 24.4035 34.563 24.3224C34.7606 24.2413 34.9398 24.1224 35.0902 23.9727C35.2406 23.823 35.3591 23.6455 35.439 23.4505C35.5189 23.2554 35.5584 23.0467 35.5554 22.8365V11.1033C35.5554 8.49403 33.3655 6.34475 30.7069 6.34475C30.1302 6.34475 29.5826 6.46127 29.0676 6.64629C28.9427 4.14267 26.8218 2.11492 24.2423 2.11492C23.456 2.11492 22.7409 2.34646 22.0811 2.67875C21.2836 1.11241 19.6683 0 17.7777 0ZM4.84846 19.0342C2.18989 19.0342 0 21.1835 0 23.7928V31.195C0 38.0244 3.55038 41.761 7.56099 43.2525C11.5716 44.7439 15.9573 44.4132 18.2007 44.4132H23.0954C26.4138 44.4427 29.4962 43.4322 31.7865 41.5093C34.0767 39.5865 35.5245 36.7238 35.5554 33.3781C35.5554 33.3733 35.5554 33.3684 35.5554 33.3636V31.6122C35.5584 31.402 35.5189 31.1933 35.439 30.9983C35.3591 30.8032 35.2406 30.6257 35.0902 30.476C34.9398 30.3263 34.7606 30.2075 34.563 30.1263C34.3655 30.0452 34.1534 30.0034 33.9392 30.0034C33.7251 30.0034 33.513 30.0452 33.3154 30.1263C33.1178 30.2075 32.9386 30.3263 32.7883 30.476C32.6379 30.6257 32.5193 30.8032 32.4395 30.9983C32.3596 31.1933 32.3201 31.402 32.3231 31.6122V33.3492C32.3001 35.8438 31.3091 37.7367 29.6863 39.0991C28.0636 40.4615 25.7572 41.2642 23.1249 41.2408C23.12 41.2408 23.1151 41.2408 23.1102 41.2408H18.2007C15.712 41.2408 11.8041 41.4388 8.70577 40.2867C5.60746 39.1345 3.23231 37.0551 3.23231 31.195V23.7928C3.23231 22.8977 3.93641 22.2066 4.84846 22.2066C5.76051 22.2066 6.46462 22.8977 6.46462 23.7928V24.8503C6.4641 24.9388 6.47114 25.0272 6.48566 25.1146C6.47054 25.2054 6.4635 25.2973 6.46462 25.3893V29.4167C6.46159 29.6269 6.50115 29.8356 6.58101 30.0307C6.66087 30.2257 6.77944 30.4032 6.92981 30.5529C7.08018 30.7026 7.25937 30.8215 7.45696 30.9026C7.65454 30.9837 7.86659 31.0255 8.08077 31.0255C8.29495 31.0255 8.507 30.9837 8.70458 30.9026C8.90217 30.8215 9.08136 30.7026 9.23173 30.5529C9.38211 30.4032 9.50067 30.2257 9.58053 30.0307C9.66039 29.8356 9.69995 29.6269 9.69692 29.4167V25.3893C9.69744 25.3008 9.6904 25.2123 9.67588 25.1249C9.691 25.0342 9.69804 24.9422 9.69692 24.8503V23.7928C9.69692 21.1835 7.50704 19.0342 4.84846 19.0342ZM18.5058 25.1993C16.04 25.1993 14.0088 27.1957 14.0088 29.615C14.0088 32.0149 15.4299 33.8907 16.8497 35.1667C17.5596 35.8046 18.2898 36.3083 18.9582 36.6744C19.6267 37.0404 20.0381 37.3415 21.0121 37.3415C22.0721 37.3415 22.4473 36.9946 23.1102 36.6021C23.773 36.2096 24.4944 35.6811 25.1935 35.0304C26.5917 33.7288 28.0154 31.922 28.0154 29.615C28.0154 27.1957 25.9821 25.1993 23.5163 25.1993C22.5732 25.1993 21.7372 25.5387 21.01 26.0316C20.2828 25.539 19.4484 25.1993 18.5058 25.1993ZM18.5058 28.3717C18.99 28.3717 19.3884 28.6257 19.6064 29.0016C19.7474 29.2451 19.9516 29.4477 20.1982 29.5886C20.4448 29.7296 20.7251 29.804 21.0104 29.8042C21.2958 29.8044 21.5762 29.7304 21.823 29.5898C22.0699 29.4492 22.2743 29.247 22.4157 29.0037C22.6355 28.6256 23.0322 28.3717 23.5163 28.3717C24.2354 28.3717 24.7831 28.9085 24.7831 29.615C24.7831 30.4931 24.014 31.757 22.9692 32.7296C22.4467 33.2158 21.8826 33.6249 21.4414 33.8861C21.2812 33.981 21.1233 34.0382 20.9932 34.0803C20.862 34.0406 20.7072 33.9973 20.5344 33.9027C20.0988 33.6641 19.5456 33.2885 19.034 32.8287C18.0107 31.9091 17.2411 30.7142 17.2411 29.615C17.2411 28.9085 17.7867 28.3717 18.5058 28.3717Z" fill="#231F20"/> </svg>
                    </span><span class="designation-card__label">General Donation</span></div></label>
                    </div>
                  </div>

                  </div>


                  <div class="ncsydeig__select">

                    <span class="ncsydeig__icon" v-if="getValue('custom.designation') == 'NCSY Region' || getValue('custom.designation') == 'NCSY Summer' || getValue('custom.designation') == 'NCSY Programs'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7324 8.98909C17.1738 9.35635 16.8165 11.2082 16.6222 11.7342C14.9309 16.3131 9.26066 16.76 5.15714 16.6535C4.78536 16.6438 3.18559 16.6609 3.09205 16.2266C2.94475 15.5421 3.25885 14.419 3.58305 13.8206C3.60345 13.7827 3.62512 13.7455 3.64801 13.7092C4.18017 12.8527 5.1483 12.1321 6.12377 11.9145C8.81478 11.3143 10.7798 13.0084 11.351 15.6007C13.8447 14.7254 15.9515 13.3828 16.3481 10.4941C16.4178 9.98677 16.2404 9.36798 16.5339 8.95188L16.7324 8.98909ZM4.03043 13.9964C3.64947 14.8285 3.62077 15.1562 3.54033 16.0669C4.0633 16.1082 4.73838 16.18 5.25125 16.1776L5.41007 16.1551C5.49087 15.933 5.50518 15.0062 5.60795 14.5976C5.06296 14.4767 4.47481 14.3584 4.03043 13.9964ZM8.22684 14.6151C7.61868 14.7321 6.65096 14.7911 6.05719 14.6258C5.96327 15.1826 5.92631 15.6101 5.88316 16.176C6.50435 16.1792 7.67231 16.1781 8.27497 16.1035L8.3701 16.0489C8.40208 15.7239 8.29136 14.9572 8.22684 14.6151ZM10.1871 14.0126C9.6594 14.2946 9.25256 14.4421 8.65289 14.5356C8.77957 14.9866 8.82214 15.5611 8.86303 16.0341L9.38264 15.9523C9.89435 15.8728 10.4025 15.7712 10.9058 15.6479C10.8108 15.3609 10.4163 14.1325 10.1871 14.0126ZM6.98752 12.3143C6.57577 13.0609 6.46565 13.3638 6.1731 14.1856C6.64041 14.2377 6.9205 14.2535 7.39103 14.25L8.13238 14.1853C7.93656 13.6374 7.66691 12.7545 7.25871 12.3539C7.13134 12.3129 7.12246 12.3135 6.98752 12.3143ZM6.21409 12.3566C5.35256 12.7132 4.87636 12.9165 4.26196 13.6791C4.36705 13.7213 4.65984 13.8478 4.75339 13.8739C5.10205 13.9867 5.35589 14.0711 5.71743 14.1413C5.89659 13.5027 6.10641 13.0064 6.38907 12.4073C6.29313 12.3393 6.34718 12.3629 6.21409 12.3566ZM7.75326 12.2931C8.1266 12.9162 8.35766 13.3783 8.55398 14.0922C8.97214 13.9908 9.18653 13.9383 9.58965 13.7874L9.61657 13.7772C9.79641 13.6863 9.78141 13.7316 9.82959 13.5902C9.65749 13.0006 8.32627 12.408 7.75326 12.2931Z" fill="#F3732B"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7596 3.351C15.226 3.32646 15.4184 3.3053 15.8757 3.44752C16.7032 3.70494 16.8647 4.46841 16.5933 5.2392C16.1878 6.39103 14.9765 7.31767 13.9148 7.83604C14.2074 8.46523 14.6252 9.79267 14.3184 10.4659C14.1402 10.8569 13.7249 10.9689 13.3509 11.0885C12.7612 10.7305 12.0566 9.59768 11.7069 8.9856C11.0438 9.3893 10.0523 9.84747 9.3348 10.2049C8.72881 10.5069 7.77811 11.0064 7.17194 11.2418C6.976 11.1493 6.76967 10.9964 6.58821 10.8708C6.30591 10.6464 4.51848 9.48023 4.43629 9.23832C4.15901 8.42211 5.17921 7.67602 6.03538 7.80696C6.68705 7.90664 7.50869 7.95202 8.20966 8.09378C8.89545 7.46882 9.59025 6.85414 10.2936 6.24983C9.99697 6.08343 8.79247 5.42144 8.67704 5.01629C8.49289 4.36986 9.34395 3.72708 9.9946 3.8289C10.6542 3.93215 11.4936 4.2901 12.16 4.59807C13.0156 3.98605 13.7216 3.5616 14.7596 3.351ZM16.0577 4.19907C15.9174 3.88922 15.2776 3.83379 14.9828 3.87333C14.5578 3.93107 14.3158 4.00112 13.9187 4.17165C14.315 4.46621 16.0917 5.38676 14.3588 6.0309C13.9688 6.17587 13.0721 5.24896 12.7489 4.88721C11.7886 5.5896 10.9901 6.31538 10.106 7.10414C9.69639 7.46965 8.77622 8.37242 8.34108 8.61898C7.39735 8.55711 5.33464 7.83939 4.92958 8.94172C4.9664 9.08535 4.93075 9.02711 5.03768 9.1243C5.68262 9.60876 6.53545 10.2253 7.21016 10.6623C7.78587 10.3649 8.36034 10.1117 8.94547 9.81445C10.8792 8.83212 12.9868 7.90471 14.767 6.66382C15.4454 6.19101 16.4726 5.06555 16.0577 4.19907ZM13.4467 8.08135C13.0084 8.34639 12.5778 8.56788 12.125 8.80358C12.4741 9.26025 12.8138 9.72444 13.1436 10.1958C13.2433 10.33 13.3399 10.4566 13.4303 10.5979C13.6145 10.4574 13.7583 10.3557 13.9168 10.1842C13.8985 9.55022 13.7676 8.72508 13.5368 8.13637C13.4956 8.10502 13.4916 8.09282 13.4467 8.08135ZM11.7446 4.96769C11.2365 4.77337 10.1899 4.28487 9.70593 4.3276C9.36225 4.47956 9.33396 4.53707 9.13824 4.86958C9.59877 5.23532 10.2223 5.59045 10.6257 5.93743L10.9809 5.60233C11.231 5.38526 11.4856 5.17367 11.7446 4.96769ZM13.4349 4.3732C13.3321 4.43832 13.1761 4.50973 13.1332 4.60272C13.3523 4.87448 14.0135 5.45032 14.3193 5.59744C14.4256 5.50934 14.5203 5.45659 14.5511 5.32844C14.3394 5.04022 13.7193 4.67336 13.4349 4.3732Z" fill="#F3732B"/>
                      </svg>
                    </span>
                    <FormSelect field="custom.programType" v-if="getValue('custom.designation') == 'NCSY Programs'">
                      <option value="General Donation">General Donation</option>
                      <option value="JSU">JSU</option>
                      <option value="Gift of Yeshiva">Gift of Yeshiva</option>
                      <option value="Ben Zakkai">Ben Zakkai</option>
                    </FormSelect>                    
                    <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'NCSY Region'">
    <option value="">Select a Region</option>
    <option value="Alumni">Alumni</option>
    <option value="Argentina">Argentina</option>
    <option value="Atlanta">Atlanta</option>
    <option value="Atlantic Seaboard">Atlantic Seaboard — Baltimore</option>
    <option value="Canada">Canada</option>
    <option value="Central East">Central East — Cincinnati, Cleveland, Columbus, Detroit, Pittsburgh</option>
    <option value="Chile">Chile</option>
    <option value="Israel">Israel</option>
    <option value="Mexico">Mexico</option>
    <option value="Midwest">Midwest</option>
    <option value="National">National</option>
    <option value="New Jersey">New Jersey</option>
    <option value="New York">New York</option>
    <option value="New England">Northeast — Boston</option>
    <option value="Oregon">Oregon</option>
    <option value="Southern">Southern</option>
    <option value="Southwest">Southwest</option>
    <option value="West Coast">West Coast</option>
  </FormSelect>

  <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'NCSY Summer'">
    <option value="">Select a Trip</option>
    <option value="General Summer Scholarship Fund">General Summer Scholarship Fund</option>
    <option value="Tefillin">Summer Tefillin Scholarship Fund</option>
    <option value="Camp Sports Scholarship">Camp Sports Scholarship Fund</option>
    <option value="Euro 4G">Euro 4G Scholarship Fund</option>
    <option value="EURO ICE Scholarship">EURO Scholarship Fund</option>
    <option value="GIVE Donation">GIVE More Scholarship Fund</option>
    <option value="GIVE Scholarship">GIVE Scholarship Fund</option>
    <option value="GIVE USA Scholarship">GIVE West Scholarship Fund</option>
    <option value="Hatzalah Rescue Israel">Hatzalah Rescue Scholarship Fund</option>
    <option value="ICE Scholarship">ICE Israel Scholarship Fund</option>
    <option value="Israel ID Scholarship">Israel ID Scholarship Fund</option>
    <option value="JOLT Israel Scholarships">JOLT Israel Scholarship Fund</option>
    <option value="Kollel Scholarship">Kollel Scholarship Fund</option>
    <option value="Michlelet Scholarship">Michlelet Scholarship Fund</option>
    <option value="MYC Israel Discovery">MYC Scholarship Fund</option>
    <option value="Next Step Israel">Next Step Scholarship Fund</option>
    <option value="EURO ICE Scholarship">Passport Scholarship Fund</option>
    <option value="TJJ Scholarship">TJJ Scholarship Fund</option>
  </FormSelect>

</div>
  <ErrorLabel field="custom.designation" style="text-align:left"/>

              <div class="dedicate__mobile__info">
            <div class="transfee" v-if="form.amount">
              <div v-if="form.amount && form.gateway !== 'check' && form.gateway !== 'wire'">
                <div class="fee-info-container">
                  <label class="fee-toggle" for="cover">
                    <input
                      id="cover"
                      class="fee-toggle__input"
                      type="checkbox"
                      :checked="form.handleProcessing"
                      @change="setValue('handleProcessing', $event.target.checked)"
                    />
                    <span class="fee-toggle__control" aria-hidden="true">
                      <span>YES</span>
                    </span>
                    <span class="fee-toggle__copy">
                      Cover the
                      <MoneyFormat
                        class="amount"
                        :value="parseInt(form.amount) * feePercent / 100"
                        :currencyCode="form.currency"
                      />
                      processing fee
                    </span>
                  </label>
                  <div
                    class="fee-tooltip-trigger"
                    @mouseenter="showFeeTooltip"
                    @mouseleave="hideFeeTooltip"
                  >
                    <button
                      type="button"
                      class="fee-tooltip-button"
                      aria-describedby="processing-fee-tooltip"
                      :aria-expanded="feeTooltipOpen"
                      @click="toggleFeeTooltip"
                      @focus="showFeeTooltip"
                      @blur="hideFeeTooltip"
                      @keydown.esc="closeFeeTooltip"
                    >
                      Why?
                    </button>
                    <div
                      v-show="feeTooltipOpen"
                      id="processing-fee-tooltip"
                      class="fee-tooltip"
                      role="tooltip"
                    >
                      <strong>Why is there a fee?</strong>
                      <p>
                        By covering the <MoneyFormat
                          class="amount"
                          :value="parseInt(form.amount) * feePercent / 100"
                          :currencyCode="form.currency"
                        /> processing fee, you help ensure {{form.applications[0].department.replace(/_/g, ' ')}} receives 100% of your intended donation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>


            </div>
          </section>
          <!-- <PaymentButton showAmount btnText="Donate" /> -->
            <div
              class="step__btn-wrapper"
              v-if="form.amount && Number(form.amount) > 0"
            >
              <div class="btn__blue" @click="goToStep(2)">Next</div>
            </div>


            <a href="https://ncsy.org/contact/" target="_blank" class="contentlink">Have a question about giving? Ask us!</a>
          </div>

          <div v-if="currentStep === 2" class="step step--lg">
            <div class="steps__infheader">
              <div class="btn__back" @click="goToStep(1)"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0906 4.41058C13.416 4.73602 13.416 5.26366 13.0906 5.58909L8.67981 9.99984L13.0906 14.4106C13.416 14.736 13.416 15.2637 13.0906 15.5891C12.7651 15.9145 12.2375 15.9145 11.912 15.5891L6.91205 10.5891C6.58661 10.2637 6.58661 9.73602 6.91205 9.41058L11.912 4.41058C12.2375 4.08514 12.7651 4.08514 13.0906 4.41058Z" fill="#231F20"/></svg></div>
              <h2>Personal Information</h2>
              <span></span>
            </div>
            
              <div class="personal__info" id="personalInfo">
                <FormRow  class="personal__firstrow" inline>
                  <div class="dform__col">
                  <label>Title
                  <FormSelect field="title" class="personal__title">      
                        <option value="">Title</option>
                        <option value="Mr">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Rabbi">Rabbi</option>
                        <option value="Rebbetzin">Rebbetzin</option>
                        <option value="Rabbanit">Rabbanit</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Dr. Rabbi">Dr. Rabbi</option>
                        <option value="Rabbi Dr." v-if="!simple">Rabbi Dr.</option>
                        <option value="Sir">Sir</option>
                        <option value="The honorable">The Honorable</option>
                        <option value="Chaplain">Chaplain</option>
                    </FormSelect>    
                  </label>
                  </div>
                  <div class="dform__col">
                    <label>First Name <span class="required">*</span>
                      <FormInput type="text" field="firstName" :flex="1"/>
                    </label>
                  <ErrorLabel field="firstName" />
                  </div>                  
                  <div class="dform__col">
                    <label>Last Name <span class="required">*</span>
                  <FormInput type="text" field="lastName" :flex="1"/>
                    </label>
                  <ErrorLabel field="lastName" />
                  </div>
                </FormRow>
                
                  <FormRow class="dform__rowdouble" inline>
                    <div class="dform__col">
                      <label>Email <span class="required">*</span>
                      <FormInput type="email" field="email" />
                      </label>
                         <ErrorLabel field="email" />
                    </div>
                    <div class="dform__col">    
                      <label>Phone <span class="required">*</span>
                      <FormCol field="phone" :flex="1" :showLabel="false" class="personal__phone">
                      <PhoneField />
                    </FormCol>      
                    </label>                               
                      </div>
                  </FormRow>

                  <div class="phonec__consent">
                        <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </div>
                  <FormRow class="personal__firstrow" inline>
                    <div class="dform__col"> 
                      <label>Street <span class="required">*</span>
                      <FormInput type="text" field="street" :showLabel="false" :flex="1"/>
                      </label>
                       <ErrorLabel field="street" />
                    </div>
                    <div class="dform__col"> 
                      <label>Street 2
                      <FormInput type="text" field="street2" :showLabel="false" :flex="1"/>
                      </label>
                       <ErrorLabel field="street2" />
                    </div>  
                    <div class="dform__col">        
                      <label>City <span class="required">*</span>
                      <FormInput type="text" field="city" :showLabel="false" :flex="1"/>
                      </label>
                       <ErrorLabel field="city" />
                    </div>                    
                  </FormRow>
                  <FormRow  class="personal__firstrow" inline>
                    <div class="dform__col">
                      <label>State <span class="required">*</span>
                      <FormSelect field="state" :disabled="form.country !== 'US' && form.country !== 'CA'" :class="{ 'personal__statehide': form.country !== 'US' && form.country !== 'CA' }">
                        <option value="" disabled selected hidden>State</option>
                        <option v-for="state of stateOptions" :key="state[1]" :value="state[1]">{{state[0]}}</option>
                      </FormSelect>    
                      </label>
                      <ErrorLabel field="state" />     
                    </div>        
                      <div class="dform__col">
                        <label>Zip <span class="required">*</span>
                        <FormInput type="text" field="zip" :showLabel="false" :flex="1"/>
                        </label>
                        <ErrorLabel field="zip" /> 
                      </div>                      
                      <div class="dform__col">
                      <label>Country <span class="required">*</span>
                      <FormCol
                      class="personal__country"
                        field="country"
                        :showLabel="false"
                        :placeholder="true"
                        placeholderText="Country"
                      >
                        <CountrySelector />
                      </FormCol>
                      </label>
                        <ErrorLabel field="country" />     
                      </div>

                  </FormRow>

                              <div class="dedicate__mobile__info">
              <div class="dedicate__modals">
              <InHonorOf/>                
              </div>

              <div class="dedicate__modals">
              	<FormRow>
  		<input type="checkbox" id="note" name="note" v-model="note"/>
  		<FormLabel for="note">I’d like to add a note</FormLabel>
	</FormRow>


  <FormRow inline v-if="note">
      <FormCol field="custom.Notes" label="Message" width="full">
        <FormInput type="textarea" field="custom.Notes" placeholder="Type your message here..." />
      </FormCol>
	</FormRow>
</div>
</div>




              </div>

          </div>
<!-- 
          <div v-if="currentStep === 3" class="step">
            <div class="gift__setup">
              <div class="personal__info" id="notes" style=" padding-top: 0px;">
                <h2>Notes</h2>
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
            </div>            
            </div>            
            <div class="step__btn-wrapper">
              <div class="btn__white" @click="currentStep = 2">Back</div>
              <div class="btn__blue" @click="currentStep = 4">Next</div>
            </div>
          </div> -->



          <div v-if="currentStep === 2" class="step">
            <div class="payment__info" title="Payment Information" last>

                          <div class="steps__infheader">
              <span></span>
              <h2>Payment Information</h2>
              <span></span>
            </div>


              
              <div class="payment__cc">
    
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              </div>
            </div>
            
            <div class="step__btn-wrapper">
                <button
                  type="submit"
                  name="submit"
                  id="donate-widget-form-submit"
                  class="ougiving__btn"
                  formnovalidate="formnovalidate"
                >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="30px"
        viewBox="0 0 1190.000000 1280.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
          fill="black"
          stroke="none"
        >
          <path
            d="M5610 11999 c-1096 -88 -1924 -626 -2375 -1544 -80 -162 -155 -347
        -155 -380 0 -8 -4 -15 -8 -15 -4 0 -8 -8 -9 -17 -1 -19 -6 -38 -16 -63 -17
        -47 -78 -287 -91 -360 -3 -19 -8 -46 -11 -59 -2 -14 -7 -47 -10 -74 -3 -28 -8
        -53 -10 -56 -8 -13 -24 -189 -28 -313 -1 -27 -5 -48 -10 -48 -4 0 -3 -9 3 -20
        8 -14 8 -20 0 -20 -7 0 -8 -6 -1 -19 6 -10 8 -21 5 -24 -3 -3 -5 -392 -4 -865
        l1 -860 -26 -20 c-14 -11 -69 -30 -123 -43 -159 -36 -266 -74 -364 -128 -109
        -60 -149 -91 -240 -183 -206 -208 -334 -560 -353 -968 -5 -99 -4 -3022 1
        -3125 8 -175 28 -319 46 -343 7 -8 7 -12 -1 -12 -7 0 -9 -5 -4 -13 4 -6 8 -16
        9 -22 1 -5 11 -34 23 -62 11 -29 17 -53 13 -53 -4 0 -2 -4 3 -8 10 -7 37 -61
        37 -72 0 -3 6 -12 14 -21 8 -9 12 -18 9 -21 -3 -3 6 -17 20 -32 13 -14 25 -29
        25 -31 0 -14 84 -117 122 -150 24 -21 34 -32 23 -24 -18 13 -19 13 -6 -3 7
        -10 17 -18 22 -18 5 0 17 -8 27 -17 39 -37 67 -57 121 -86 175 -94 267 -121
        521 -153 111 -13 461 -15 3121 -14 3106 0 3123 0 3314 39 221 45 397 134 531
        270 161 162 238 342 269 626 12 107 15 407 15 1696 0 862 -2 1573 -4 1580 -3
        8 -7 63 -10 122 -4 60 -8 112 -10 116 -3 4 -7 27 -10 51 -17 143 -76 342 -137
        463 -30 57 -107 176 -138 211 -62 69 -159 160 -174 164 -13 3 -37 30 -38 44 0
        7 -4 4 -8 -7 -8 -19 -8 -19 -15 3 -5 14 -13 21 -21 18 -8 -3 -19 2 -25 10 -7
        8 -19 14 -26 14 -8 0 -14 5 -14 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -9
        10 -20 10 -11 0 -20 5 -20 11 0 5 -4 7 -10 4 -5 -3 -10 -1 -10 5 0 6 -4 8 -10
        5 -5 -3 -10 -2 -10 4 0 5 -8 8 -17 6 -10 -1 -30 4 -45 11 -15 8 -31 13 -35 13
        -4 -1 -16 1 -25 4 -46 18 -54 20 -69 23 -9 2 -27 8 -40 13 -13 5 -27 8 -30 7
        -4 0 -17 8 -30 19 -14 13 -20 14 -15 5 4 -8 -4 -2 -18 13 l-26 28 0 847 c-1
        466 -3 883 -5 927 -7 117 -14 206 -19 240 -3 24 -26 169 -40 255 -21 125 -30
        170 -36 170 -4 0 -6 10 -5 23 1 12 -1 27 -5 32 -5 6 -11 24 -13 40 -9 46 -14
        68 -25 96 -6 15 -8 29 -6 32 3 3 -2 22 -10 42 -9 21 -16 47 -16 59 0 16 -2 18
        -9 7 -7 -10 -11 -1 -16 32 -4 26 -12 47 -17 47 -6 0 -8 9 -5 20 3 11 1 20 -4
        20 -5 0 -9 7 -9 15 0 8 -4 15 -10 15 -5 0 -6 7 -3 17 5 11 3 14 -6 8 -10 -6
        -11 -2 -6 15 5 17 4 21 -5 15 -8 -5 -11 -4 -6 3 7 11 -28 93 -96 227 -22 44
        -55 107 -71 140 -17 33 -34 62 -38 65 -3 3 -16 25 -29 49 -12 24 -26 49 -31
        55 -30 36 -84 113 -105 149 -13 23 -24 38 -24 34 0 -4 -6 -2 -14 5 -8 7 -12
        16 -9 20 2 4 -7 19 -21 33 -15 14 -26 31 -26 37 0 6 -3 8 -7 5 -3 -4 -13 2
        -20 13 -8 11 -19 18 -24 15 -5 -4 -9 2 -9 12 0 11 -20 39 -45 63 -24 24 -42
        47 -39 52 3 4 -4 8 -15 8 -11 0 -22 9 -26 20 -3 11 -13 20 -21 20 -8 0 -14 7
        -14 15 0 8 -7 15 -16 15 -8 0 -12 5 -9 10 3 6 -1 10 -9 10 -9 0 -16 5 -16 11
        0 5 -3 8 -7 6 -5 -3 -14 1 -21 9 -7 8 -9 14 -5 14 4 1 -4 8 -19 16 -16 8 -28
        19 -28 24 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -5 10 -10 10 -6 0 -21 11
        -34 25 -13 14 -26 25 -30 25 -7 0 -67 41 -76 51 -3 3 -19 13 -37 22 -17 9 -37
        22 -45 29 -18 17 -59 42 -143 85 -38 19 -73 40 -76 45 -3 5 -9 9 -12 9 -4 0
        -26 8 -49 18 -374 158 -665 229 -1072 261 -150 12 -504 11 -656 -1z m475
        -1214 c103 -10 140 -15 240 -31 90 -15 283 -67 314 -85 17 -9 74 -31 79 -30
        10 4 273 -148 292 -170 3 -3 23 -18 44 -35 22 -16 49 -38 60 -49 12 -11 35
        -31 51 -43 17 -13 23 -21 15 -17 -8 4 -1 -6 16 -22 27 -24 98 -107 157 -184
        10 -13 27 -40 38 -59 11 -19 28 -48 39 -65 19 -30 73 -126 75 -135 1 -3 10
        -23 20 -45 10 -22 18 -43 17 -47 -1 -5 2 -8 6 -8 5 0 9 -6 10 -12 2 -29 29
        -88 37 -81 4 5 5 3 1 -4 -4 -7 7 -50 23 -97 16 -46 27 -87 24 -90 -3 -3 0 -12
        7 -21 7 -9 10 -18 7 -22 -4 -3 -2 -12 4 -20 9 -10 8 -13 -2 -13 -9 -1 -8 -5 5
        -15 11 -8 15 -15 8 -15 -8 0 -9 -7 -1 -27 6 -16 12 -37 14 -48 8 -49 27 -203
        29 -230 0 -16 5 -33 11 -37 7 -5 6 -8 0 -8 -6 0 -11 -9 -11 -20 0 -11 4 -20 9
        -20 5 0 4 -6 -2 -14 -9 -11 -9 -15 1 -20 10 -5 10 -7 1 -12 -19 -8 -16 -24 5
        -24 10 0 13 -3 6 -8 -16 -10 -18 -222 -3 -222 8 0 9 -4 0 -13 -8 -10 -12 -215
        -13 -707 l-3 -694 -34 -20 c-34 -20 -56 -20 -1717 -24 -1216 -3 -1683 -1
        -1688 7 -4 6 -22 11 -40 11 -69 0 -65 -59 -66 905 -1 479 -1 872 0 875 1 3 3
        32 5 65 4 65 10 117 26 210 6 33 12 71 13 85 2 14 6 32 10 41 4 9 8 27 10 41
        1 13 5 28 8 33 3 6 9 28 13 50 8 42 47 159 71 212 8 17 14 34 14 39 0 33 188
        356 247 424 36 42 197 200 239 235 110 93 398 240 507 259 7 1 28 7 47 14 58
        19 273 52 382 58 57 4 104 7 105 8 4 3 156 -3 218 -9z"
          />
        </g>
      </svg>                
                    <span v-if="processing">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </span>
                    <span v-else class="btnpayment__text">
                    
                      <span v-if="form.dayOfMonth && form.dayOfMonth > 0">Give Monthly</span>
                      <span v-else>
                      Donate Now
                        </span>
                      <MoneyFormat
                        v-if="form.amount"
                        class="amount"
                        :value="amount"
                        :currencyCode="form.currency"
                        :hideSubunits="Number.isInteger(amount)"
                      />
                    </span>
                  </button>
                </div>

          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch, computed, inject, nextTick } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'
import { scrollToStepsBar } from '~/shared/scroll-to-steps-bar'
import { string } from 'zod'

import FormSelect from '~/components/form-select.vue'
import MoneyFormat from '~/components/MoneyFormat.vue'

const states = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Lousiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
]

const provinces = [
  ['Alberta', 'AB'],
  ['British Columbia', 'BC'],
  ['Manitoba', 'MB'],
  ['New Brunswick', 'NB'],
  ['Newfoundland', 'NL'],
  ['Northwest Territories', 'NT'],
  ['Nova Scotia', 'NS'],
  ['Nunavut', 'NU'],
  ['Ontario', 'ON'],
  ['Prince Edward Island', 'PE'],
  ['Quebec', 'QC'],
  ['Saskatchewan', 'SK'],
  ['Yukon', 'YT'],
]

export default defineComponent({
  components: {
    MoneyFormat
  },
  setup(_props: {}) {
    const { form, setValue, getValue, setTouched, errors, submit, submitting } = usePaymentForm()
        const isDev = import.meta.dev

    const params = queryParams()
    const feePercent = 2.5
    const inHonorOf = ref(false)
    const note = ref(false)
    const feeTooltipOpen = ref(false)
    const feeTooltipPinned = ref(false)
	  const recipientFlag = true

    const showFeeTooltip = () => {
      feeTooltipOpen.value = true
    }

    const hideFeeTooltip = () => {
      if (!feeTooltipPinned.value) feeTooltipOpen.value = false
    }

    const toggleFeeTooltip = () => {
      feeTooltipPinned.value = !feeTooltipPinned.value
      feeTooltipOpen.value = feeTooltipPinned.value
    }

    const closeFeeTooltip = () => {
      feeTooltipPinned.value = false
      feeTooltipOpen.value = false
    }
    // setValue('amount', '18');

    const designations = [
      { value: 'NCSY Region', label: 'NCSY Region', icon: '<svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3554 11.3117C28.2382 12.0462 27.5237 15.7498 27.1351 16.802C23.7524 25.9596 12.4119 26.8534 4.20491 26.6404C3.46134 26.6211 0.261814 26.6554 0.074722 25.7866C-0.219884 24.4176 0.408332 22.1714 1.05673 20.9747C1.09753 20.8989 1.14087 20.8245 1.18665 20.7518C2.25096 19.0389 4.18722 17.5977 6.13816 17.1626C11.5202 15.9621 15.4503 19.3503 16.5927 24.5349C21.5801 22.7844 25.7936 20.0991 26.5868 14.3217C26.7262 13.307 26.3714 12.0695 26.9584 11.2373L27.3554 11.3117ZM1.95149 21.3263C1.18957 22.9906 1.13216 23.6458 0.971283 25.4673C2.01722 25.5498 3.36739 25.6935 4.39312 25.6887L4.71076 25.6437C4.87236 25.1995 4.90098 23.3459 5.10652 22.5286C4.01655 22.2869 2.84025 22.0504 1.95149 21.3263ZM10.3443 22.5636C9.12799 22.7978 7.19254 22.9157 6.005 22.585C5.81717 23.6986 5.74325 24.5537 5.65695 25.6855C6.89932 25.6919 9.23524 25.6898 10.4406 25.5406L10.6308 25.4312C10.6948 24.7814 10.4733 23.2479 10.3443 22.5636ZM14.2648 21.3587C13.2094 21.9227 12.3957 22.2178 11.1964 22.4046C11.4498 23.3067 11.5349 24.4557 11.6167 25.4017L12.6559 25.2381C13.6793 25.0792 14.6957 24.8759 15.7022 24.6292C15.5123 24.0553 14.7232 21.5985 14.2648 21.3587ZM7.86567 17.9622C7.04217 19.4554 6.82192 20.061 6.23683 21.7047C7.17145 21.8089 7.73162 21.8406 8.67269 21.8334L10.1554 21.7042C9.76375 20.6083 9.22444 18.8426 8.40805 18.0414C8.1533 17.9594 8.13554 17.9606 7.86567 17.9622ZM6.3188 18.0466C4.59575 18.7599 3.64334 19.1666 2.41455 20.6917C2.62472 20.7762 3.21031 21.0291 3.3974 21.0813C4.09473 21.3068 4.60241 21.4757 5.32549 21.616C5.6838 20.3389 6.10344 19.3463 6.66877 18.1481C6.47688 18.0121 6.58499 18.0593 6.3188 18.0466ZM9.39715 17.9197C10.1438 19.1659 10.6059 20.0902 10.9986 21.5179C11.8349 21.3151 12.2637 21.2101 13.0699 20.9084L13.1238 20.8879C13.4834 20.7061 13.4535 20.7966 13.5498 20.514C13.2056 19.3348 10.5432 18.1495 9.39715 17.9197Z" fill="#231F20"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M23.4098 0.0354999C24.3426 -0.0135864 24.7274 -0.055913 25.6421 0.228543C27.2971 0.743386 27.62 2.27031 27.0772 3.8119C26.2661 6.11556 23.8436 7.96884 21.7202 9.00557C22.3054 10.2639 23.141 12.9188 22.5274 14.2652C22.171 15.0472 21.3404 15.2713 20.5925 15.5105C19.413 14.7945 18.0039 12.5288 17.3044 11.3047C15.9783 12.1121 13.9951 13.0284 12.5602 13.7434C11.3482 14.3474 9.44685 15.3462 8.23451 15.8172C7.84262 15.6321 7.42996 15.3263 7.06705 15.0751C6.50245 14.6263 2.92759 12.294 2.7632 11.8101C2.20864 10.1777 4.24905 8.68554 5.96138 8.94743C7.26473 9.14678 8.90801 9.23754 10.3099 9.52105C11.6815 8.27113 13.0711 7.04179 14.4779 5.83315C13.8846 5.50036 11.4756 4.17637 11.2447 3.36607C10.8764 2.07322 12.5785 0.787649 13.8798 0.991289C15.1991 1.19779 16.8779 1.91371 18.2106 2.52963C19.9218 1.30559 21.3339 0.456686 23.4098 0.0354999ZM26.006 1.73163C25.7254 1.11194 24.4459 1.00108 23.8563 1.08016C23.0061 1.19563 22.5222 1.33573 21.7281 1.67679C22.5207 2.26592 26.074 4.10701 22.6082 5.39529C21.8282 5.68523 20.0349 3.83142 19.3884 3.10791C17.4679 4.51269 15.8707 5.96425 14.1027 7.54177C13.2834 8.2728 11.4431 10.0783 10.5728 10.5715C8.68533 10.4477 4.5599 9.01228 3.74978 11.2169C3.82343 11.5042 3.75213 11.3877 3.96599 11.5821C5.25587 12.551 6.96153 13.7842 8.31094 14.658C9.46237 14.0633 10.6113 13.5569 11.7816 12.9624C15.6489 10.9977 19.8642 9.14292 23.4247 6.66115C24.7814 5.71553 26.8357 3.46459 26.006 1.73163ZM20.784 9.4962C19.9074 10.0263 19.0462 10.4693 18.1405 10.9407C18.8389 11.854 19.5182 12.7824 20.1779 13.7251C20.3772 13.9934 20.5705 14.2467 20.7511 14.5294C21.1196 14.2483 21.4073 14.0448 21.7241 13.7019C21.6877 12.4339 21.4258 10.7837 20.9642 9.60624C20.8818 9.54354 20.8739 9.51914 20.784 9.4962ZM17.3798 3.26888C16.3637 2.88023 14.2703 1.90324 13.3025 1.9887C12.6151 2.29262 12.5586 2.40765 12.1671 3.07265C13.0882 3.80414 14.3351 4.5144 15.1421 5.20837L15.8524 4.53816C16.3526 4.10402 16.8618 3.68083 17.3798 3.26888ZM20.7604 2.07989C20.5548 2.21013 20.2428 2.35295 20.1571 2.53894C20.5953 3.08246 21.9177 4.23413 22.5292 4.52837C22.7419 4.35217 22.9312 4.24667 22.9929 3.99037C22.5694 3.41394 21.3292 2.68021 20.7604 2.07989Z" fill="#231F20"/> </svg>' },
      { value: 'NCSY Summer', label: 'NCSY Summer', icon: '<svg width="31" height="29" viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M19.5158 27.6214C21.0426 27.8114 23.0297 25.886 24.632 26.2854C25.9251 26.6076 26.904 27.3012 28.3505 27.7637C29.3477 27.4671 29.8031 26.8284 30.681 26.9408L30.8148 27.1252C30.7966 27.3397 30.7601 27.5282 30.6238 27.7004C28.2532 30.6932 26.1674 27.0202 23.3062 27.5921C21.1499 28.4574 20.328 29.536 17.7906 28.2405C17.1514 27.9145 16.1688 27.5611 15.4492 27.4202L15.3761 27.4066C13.6374 27.771 12.1215 29.3629 10.3302 28.7479C9.47032 28.4525 8.71674 27.8818 7.73759 27.5894C6.43978 27.2019 6.08927 27.6604 4.90896 28.1019C4.69223 28.2601 4.37491 28.3156 4.17366 28.4842C3.31139 29.2069 0.106258 28.6583 0.148704 27.3032C0.775874 26.413 1.23114 27.8499 2.59019 27.6996C4.22379 27.5186 4.99295 26.6138 6.60817 26.3159C8.7339 26.2829 9.04577 27.4021 10.8876 27.654C12.1983 27.8333 13.7714 26.4718 15.1801 26.3235C16.9419 26.138 17.8734 27.3823 19.5158 27.6214Z" fill="#231F20"/> <path d="M24.1413 22.2568C26.1187 22.4247 26.2174 23.1298 27.9293 23.6056C28.4407 23.7479 29.9249 22.5977 30.6688 22.8203C30.8465 23.1113 30.8003 22.9922 30.7601 23.3942C30.4301 23.8845 29.6972 24.3396 29.1968 24.6956C26.2259 24.942 26.915 23.9214 24.4348 23.5416C23.16 23.3465 21.5564 24.8064 20.0089 24.7639C18.0913 24.7111 17.1647 23.5231 15.258 23.532C13.596 23.5398 12.7376 25.0632 10.9981 24.7727C8.90022 24.4224 8.84395 23.5551 6.45549 23.4615C5.11777 23.7712 4.13307 24.8381 2.48634 24.7191C1.42696 24.6425 -0.0347463 24.1592 0.000630137 22.8567C0.322672 22.4288 0.272264 22.45 0.734184 22.7151C1.09582 22.9224 2.21141 23.6349 2.5729 23.658C4.24227 23.7647 5.34393 22.0884 7.2187 22.2886C8.89687 22.4678 9.71397 23.7856 11.2697 23.5984C12.9848 23.392 13.982 22.2176 15.8717 22.2905C17.4338 22.3507 18.7621 23.7605 20.1647 23.6172C21.515 23.4793 22.4441 22.5633 23.9868 22.284L24.1413 22.2568Z" fill="#231F20"/> <path d="M21.6383 17.527C21.7023 17.5169 21.7678 17.5198 21.8306 17.5355C21.8935 17.5512 21.9528 17.5793 22.0047 17.6183L23.6018 18.7664C23.6919 18.8295 23.7583 18.9215 23.7902 19.0274C23.8198 19.126 23.8179 19.2316 23.7848 19.3291C23.7516 19.4266 23.6889 19.5112 23.6055 19.5707C23.5221 19.6303 23.4223 19.6619 23.3201 19.6611C23.2179 19.6602 23.1184 19.627 23.036 19.5661L21.4389 18.418C21.3854 18.3811 21.3398 18.3338 21.3046 18.2789C21.2695 18.224 21.2455 18.1625 21.2342 18.0982C21.2229 18.0338 21.2244 17.9678 21.2387 17.9041C21.2529 17.8403 21.2797 17.7801 21.3173 17.7269C21.3549 17.6737 21.4028 17.6287 21.4579 17.5943C21.513 17.56 21.5744 17.5371 21.6383 17.527Z" fill="#231F20"/> <path d="M7.36931 16.9227C7.47147 16.9203 7.57182 16.9503 7.6561 17.0086C7.74038 17.0669 7.80429 17.1505 7.83889 17.2475C7.87349 17.3445 7.877 17.45 7.84888 17.5491C7.82075 17.6481 7.76249 17.7358 7.68226 17.7996L6.15839 19.045C6.10886 19.0871 6.05139 19.1187 5.98955 19.1382C5.92772 19.1577 5.86268 19.1645 5.7982 19.1583C5.73371 19.1521 5.67105 19.1331 5.61398 19.1022C5.55689 19.0713 5.5065 19.0291 5.46574 18.9783C5.42499 18.9275 5.3947 18.869 5.37665 18.8062C5.35859 18.7435 5.35302 18.6777 5.36047 18.6128C5.36793 18.5479 5.38829 18.4851 5.42008 18.4282C5.45189 18.3713 5.49462 18.3213 5.5458 18.2813L7.06967 17.0359C7.15406 16.9653 7.25964 16.9254 7.36931 16.9227Z" fill="#231F20"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4994 5.00593C18.0851 4.64345 21.3143 7.2037 21.8123 10.8045C22.3102 14.4052 19.8993 17.7597 16.3525 18.4015C13.932 18.8394 11.4689 17.9064 9.93175 15.9702C8.39496 14.0339 8.03126 11.4047 8.98385 9.11785C9.93647 6.83104 12.0533 5.25323 14.4994 5.00593ZM20.5958 11.062C20.2135 8.04254 17.4862 5.90133 14.491 6.26981C11.4726 6.64127 9.32984 9.41942 9.71471 12.4625C10.0996 15.5056 12.8655 17.652 15.879 17.2469C18.8705 16.8449 20.9769 14.0814 20.5958 11.062Z" fill="#231F20"/> <path d="M27.7669 11.1021C27.8766 11.0982 27.9844 11.1317 28.0727 11.1972C28.155 11.2583 28.2162 11.344 28.2476 11.442C28.279 11.5401 28.279 11.6457 28.2476 11.7438C28.2162 11.8419 28.155 11.9275 28.0727 11.9886C27.9904 12.0497 27.8911 12.0832 27.789 12.0842L24.6919 12.1304C24.6272 12.1332 24.5624 12.1231 24.5017 12.1004C24.4409 12.0777 24.3854 12.0428 24.3381 11.9982C24.2908 11.9535 24.2528 11.8998 24.2263 11.8402C24.1999 11.7805 24.1854 11.7161 24.184 11.6507C24.1825 11.5854 24.194 11.5204 24.2177 11.4596C24.2415 11.3988 24.277 11.3433 24.3222 11.2965C24.3675 11.2498 24.4216 11.2126 24.4812 11.1872C24.5409 11.1617 24.605 11.1485 24.6697 11.1483L27.7669 11.1021Z" fill="#231F20"/> <path d="M5.88238 10.8485C5.99196 10.8433 6.10018 10.8756 6.18931 10.9401C6.27228 11.0002 6.33438 11.0851 6.36687 11.1828C6.39937 11.2806 6.40063 11.3861 6.37036 11.4846C6.34009 11.583 6.2798 11.6694 6.19819 11.7315C6.11659 11.7935 6.01765 11.8281 5.91552 11.8303L3.1438 11.8991C3.0791 11.9026 3.01425 11.8931 2.95324 11.8711C2.89225 11.8491 2.8363 11.8149 2.78852 11.7708C2.74073 11.7267 2.70212 11.6734 2.675 11.6141C2.64789 11.5548 2.63267 11.4905 2.63045 11.4253C2.62825 11.3599 2.63911 11.2948 2.66216 11.2337C2.68521 11.1726 2.72003 11.1168 2.76474 11.0695C2.80945 11.0222 2.86309 10.9843 2.92248 10.9582C2.98187 10.932 3.04587 10.9181 3.11066 10.9172L5.88238 10.8485Z" fill="#231F20"/> <path d="M6.80174 3.14386C6.86583 3.13433 6.93114 3.13784 6.99389 3.15409C7.05665 3.17035 7.11555 3.19902 7.16717 3.23852L8.75429 4.40086C8.8438 4.46478 8.90936 4.55729 8.94026 4.66342C8.96899 4.7623 8.96614 4.86782 8.93217 4.965C8.89818 5.06218 8.8347 5.1462 8.7508 5.20501C8.66688 5.26383 8.56666 5.29455 8.46448 5.2928C8.36231 5.29104 8.26322 5.25692 8.18134 5.19526L6.59437 4.03292C6.54122 3.99557 6.49603 3.94789 6.46136 3.89269C6.42669 3.83747 6.40315 3.77581 6.3924 3.71136C6.38165 3.64694 6.38375 3.58098 6.39858 3.51739C6.41341 3.45377 6.44069 3.39372 6.4788 3.34086C6.5169 3.28802 6.56512 3.24341 6.62053 3.20958C6.67597 3.17574 6.73764 3.1534 6.80174 3.14386Z" fill="#231F20"/> <path d="M23.1259 3.0041C23.228 3.00171 23.3284 3.0317 23.4127 3.08997C23.497 3.14825 23.5609 3.23189 23.5955 3.32887C23.6301 3.42584 23.6336 3.53136 23.6055 3.63045C23.5773 3.72952 23.5191 3.8172 23.4388 3.88101L21.915 5.12634C21.8654 5.16847 21.808 5.20024 21.7461 5.21973C21.6843 5.2392 21.6193 5.24606 21.5548 5.23987C21.4903 5.23368 21.4276 5.21449 21.3706 5.18359C21.3135 5.15268 21.2631 5.1106 21.2223 5.05982C21.1816 5.00901 21.1513 4.95037 21.1332 4.88761C21.1152 4.82488 21.1096 4.75917 21.1171 4.69428C21.1245 4.62938 21.1447 4.56652 21.1765 4.50959C21.2083 4.45266 21.2512 4.40271 21.3024 4.36264L22.8263 3.11732C22.9106 3.04663 23.0162 3.00673 23.1259 3.0041Z" fill="#231F20"/> <path d="M15.1072 0.0246239C15.2043 -0.00763821 15.3089 -0.00817064 15.4064 0.0228649C15.5038 0.0539042 15.5891 0.115016 15.6502 0.197639C15.7113 0.280263 15.7451 0.380188 15.7468 0.483227L15.8046 3.11556C15.8078 3.18083 15.7981 3.24618 15.7759 3.3076C15.7538 3.36899 15.7197 3.4253 15.6757 3.47326C15.6317 3.52124 15.5786 3.55991 15.5196 3.58695C15.4606 3.61397 15.3969 3.62888 15.3322 3.63077C15.2674 3.63265 15.2028 3.6214 15.1424 3.59783C15.082 3.57425 15.0269 3.53874 14.9802 3.49341C14.9336 3.44807 14.8963 3.39386 14.8707 3.33382C14.8451 3.27379 14.8316 3.20921 14.831 3.14386L14.7732 0.51153C14.7686 0.400994 14.8012 0.292141 14.8656 0.202596C14.9257 0.1192 15.0102 0.0568903 15.1072 0.0246239Z" fill="#231F20"/> </svg>' },
      { value: 'NCSY Education', label: 'NCSY Education', icon: '<svg width="30" height="23" viewBox="0 0 30 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.53506 0.0269969C9.13264 -0.14846 13.4338 0.49346 14.6803 3.07221C16.1932 1.6839 18.1549 0.87652 20.2132 0.795001C22.1732 0.704814 24.506 1.26377 26.1076 2.4202C26.7363 2.8745 26.717 5.76188 26.2326 6.26283C25.2472 6.45563 25.6065 3.87346 25.6149 3.21132C22.4209 0.849357 17.4573 1.29782 14.7984 4.29985C14.7542 7.15935 14.7891 10.1093 14.787 12.976L14.7858 19.3045C15.645 18.8119 16.5902 18.3901 17.5496 18.1417C18.2061 17.9725 19.0808 17.5949 19.5206 18.2901C19.5106 18.8468 18.5461 18.921 18.0777 18.9969C17.083 19.1586 16.0085 19.6837 15.1355 20.168C13.9391 20.9431 13.3766 20.1063 12.3568 19.5545C9.60518 18.065 6.72946 18.1034 3.77075 18.8852C3.06883 19.0711 2.1282 18.9552 2.1188 18.0033C2.06734 12.8061 2.11013 7.60026 2.10677 2.40197C2.10661 2.1519 2.13911 1.58792 2.29062 1.36921C3.16444 0.382252 5.29992 0.122939 6.53506 0.0269969ZM13.7322 3.50754C13.4416 1.53208 8.53259 0.816934 6.9364 0.944956C5.89955 1.02989 3.89805 1.19808 3.13703 1.892C2.94456 2.41913 2.9741 16.6413 3.0332 18.1525C5.80237 17.3806 7.9783 17.0064 10.8242 17.8957C12.1072 18.3567 12.6747 18.6043 13.8212 19.3478L13.815 8.5816C13.816 7.18386 13.9238 4.80917 13.7322 3.50754Z" fill="#231F20"/> <path d="M6.94508 12.1132C7.9251 11.9855 11.3188 12.0945 11.7208 13.0964L11.6374 13.2164C10.9579 13.4875 10.5473 13.329 9.8436 13.1885C8.24341 12.9088 6.98881 13.0454 5.4049 13.1935C5.18455 13.2141 5.12017 13.1525 4.95808 13.0304C4.87069 12.714 4.86717 12.8452 4.96983 12.5349C5.35521 12.1737 6.38493 12.1656 6.94508 12.1132Z" fill="#231F20"/> <path d="M6.50623 5.86075C7.44688 5.70397 10.4674 5.837 11.3864 6.32486C11.6031 6.43997 11.5841 6.59259 11.6127 6.79122C11.3729 7.39503 10.5928 7.05203 10.0626 6.92942C9.16946 6.77022 8.4625 6.74346 7.56222 6.74196C7.00443 6.74104 5.37083 7.00277 4.99602 6.77597C4.86172 6.47173 4.87674 6.60009 4.91947 6.28769C5.25272 5.9041 5.97705 5.91643 6.50623 5.86075Z" fill="#231F20"/> <path d="M7.3757 8.94623C8.24903 8.92597 9.12254 8.98232 9.98597 9.11469C10.5129 9.1932 11.3359 9.30998 11.6651 9.75092C11.628 10.6553 9.89691 10.0205 9.21714 9.94204C7.95692 9.81118 5.36654 10.1911 4.84493 9.7475C4.79616 8.92105 6.7986 8.98482 7.3757 8.94623Z" fill="#231F20"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8043 6.37424C23.5186 6.48956 24.3622 8.26234 24.7517 8.93291C25.5466 8.92941 26.3533 8.92283 27.1499 8.91349C27.5848 8.90849 27.9978 8.89531 28.2085 9.31941C28.1875 9.91713 27.0862 11.4322 26.6992 12.0248C27.1097 12.6496 28.4192 14.2915 28.1195 14.9336C27.6201 15.2832 25.4686 15.1466 24.761 15.1447C24.306 15.902 23.689 17.0039 23.1778 17.6874C22.6246 17.6674 22.5289 17.3998 22.2452 16.9639C21.8599 16.3712 21.5124 15.7467 21.1606 15.1339C20.2239 15.1325 19.2023 15.2044 18.2689 15.1131C17.9466 15.0816 17.8475 14.9582 17.7459 14.6933C17.7895 14.0801 18.8498 12.6497 19.2418 12.0603C18.8481 11.4467 17.5688 9.78073 17.8324 9.15492C18.3067 8.77894 20.4001 8.9258 21.1531 8.9328C21.5577 8.26557 22.3351 6.92403 22.8043 6.37424ZM22.1782 15.1533C22.378 15.4872 22.6752 16.1428 22.9606 16.292C23.1822 16.197 23.1746 16.1103 23.3165 15.8686L23.753 15.1475L22.1782 15.1533ZM26.1563 12.886C25.9431 13.218 25.4754 13.8058 25.4931 14.1408C25.7348 14.3441 25.9489 14.2905 26.314 14.2865C26.6196 14.2689 26.7221 14.3227 26.8883 14.1469C26.8732 13.7674 26.4065 13.1531 26.1563 12.886ZM24.2742 9.81018C23.4272 9.80543 22.4955 9.78057 21.6561 9.80074L20.2567 12.0306L21.6376 14.2887L24.2742 14.2862C24.73 13.5491 25.2026 12.7542 25.6945 12.047L24.2742 9.81018ZM19.7128 12.8891C19.5054 13.202 19.0194 13.8057 19.0186 14.1259C19.1932 14.304 19.2369 14.283 19.5567 14.2862C19.6398 14.2864 19.7237 14.2856 19.8076 14.2839C20.1367 14.2722 20.2131 14.3308 20.4078 14.1485C20.4153 13.7799 19.9503 13.162 19.7128 12.8891ZM20.628 9.81648C20.0631 9.81097 19.4159 9.78927 18.8577 9.81561C19.0869 10.2038 19.3798 10.8376 19.729 11.0593C19.9414 10.9646 19.8868 10.9706 20.0396 10.7432L20.628 9.81648ZM27.0753 9.81908C26.4852 9.80641 25.9152 9.78732 25.3243 9.82049C25.5342 10.1643 25.88 10.8724 26.1729 11.056C26.4113 10.9605 26.345 10.9722 26.5146 10.7093L27.0753 9.81908ZM22.1918 8.90948L23.3015 8.93443L23.576 8.89331C23.6507 8.57423 23.168 7.89694 22.9304 7.71656L22.1918 8.90948Z" fill="#231F20"/> <path d="M0.26596 3.46311C0.560765 3.47862 0.595681 3.4667 0.845829 3.60356C1.1126 3.97673 1.00641 7.66284 1.00607 8.37101L0.999696 16.8388C0.996842 17.8866 0.920289 19.4028 1.07088 20.4347C1.00784 20.488 1.31389 20.5872 1.28342 20.5964C6.4938 19.116 9.32232 18.831 14.2796 21.4032C19.299 18.8043 23.2477 19.3377 28.4454 20.9114C28.4714 20.0404 28.2129 17.1406 28.8458 16.683C29.5014 16.7438 29.4199 17.3014 29.4057 17.789C29.3931 18.6984 29.5987 20.528 29.1731 21.3299C28.6888 22.2401 26.9394 21.4066 26.142 21.194C24.8677 20.8656 23.5641 20.6597 22.2496 20.5789C20.3508 20.4738 18.5385 20.6655 16.7463 21.3274C16.0605 21.5808 14.9295 22.1667 14.2714 22.2201C13.7025 22.2668 12.5095 21.5341 11.8949 21.2874C9.43824 20.293 6.92266 20.2563 4.33699 20.8006C3.26463 20.9473 1.55464 21.8392 0.537681 21.3874C-0.166007 21.0748 0.0231145 18.956 0.0231145 18.2858L0.0275616 7.36911C0.0280653 6.59451 -0.10901 3.97023 0.26596 3.46311Z" fill="#231F20"/> </svg>' },
      // { value: 'General Donation', label: 'General Donation', icon: '<svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17.7777 0C15.8871 0 14.2718 1.11241 13.4743 2.67875C12.8145 2.34646 12.0994 2.11492 11.3131 2.11492C8.6545 2.11492 6.46462 4.2642 6.46462 6.87347V14.3996C6.46159 14.6098 6.50115 14.8185 6.58101 15.0135C6.66087 15.2086 6.77944 15.3861 6.92981 15.5358C7.08018 15.6855 7.25937 15.8043 7.45696 15.8855C7.65454 15.9666 7.86659 16.0084 8.08077 16.0084C8.29495 16.0084 8.507 15.9666 8.70458 15.8855C8.90217 15.8043 9.08136 15.6855 9.23173 15.5358C9.38211 15.3861 9.50067 15.2086 9.58053 15.0135C9.66039 14.8185 9.69995 14.6098 9.69692 14.3996V6.87347C9.69692 5.97834 10.401 5.28729 11.3131 5.28729C12.2251 5.28729 12.9292 5.97834 12.9292 6.87347V20.6204C12.9262 20.8306 12.9658 21.0393 13.0456 21.2343C13.1255 21.4294 13.2441 21.6069 13.3944 21.7566C13.5448 21.9063 13.724 22.0252 13.9216 22.1063C14.1192 22.1874 14.3312 22.2292 14.5454 22.2292C14.7596 22.2292 14.9716 22.1874 15.1692 22.1063C15.3668 22.0252 15.546 21.9063 15.6963 21.7566C15.8467 21.6069 15.9653 21.4294 16.0451 21.2343C16.125 21.0393 16.1646 20.8306 16.1615 20.6204V4.75856C16.1615 3.86342 16.8656 3.17237 17.7777 3.17237C18.6897 3.17237 19.3938 3.86342 19.3938 4.75856V20.6204C19.3908 20.8306 19.4304 21.0393 19.5102 21.2343C19.5901 21.4294 19.7087 21.6069 19.859 21.7566C20.0094 21.9063 20.1886 22.0252 20.3862 22.1063C20.5838 22.1874 20.7958 22.2292 21.01 22.2292C21.2242 22.2292 21.4362 22.1874 21.6338 22.1063C21.8314 22.0252 22.0106 21.9063 22.161 21.7566C22.3113 21.6069 22.4299 21.4294 22.5098 21.2343C22.5896 21.0393 22.6292 20.8306 22.6262 20.6204V6.87347C22.6262 5.97834 23.3303 5.28729 24.2423 5.28729C25.1544 5.28729 25.8585 5.97834 25.8585 6.87347V19.563C25.8554 19.7732 25.895 19.9818 25.9749 20.1769C26.0547 20.3719 26.1733 20.5495 26.3237 20.6992C26.474 20.8488 26.6532 20.9677 26.8508 21.0488C27.0484 21.13 27.2604 21.1717 27.4746 21.1717C27.6888 21.1717 27.9008 21.13 28.0984 21.0488C28.296 20.9677 28.4752 20.8488 28.6256 20.6992C28.776 20.5495 28.8945 20.3719 28.9744 20.1769C29.0542 19.9818 29.0938 19.7732 29.0908 19.563V11.1033C29.0908 10.2082 29.7949 9.51712 30.7069 9.51712C31.619 9.51712 32.3231 10.2082 32.3231 11.1033V22.8365C32.3201 23.0467 32.3596 23.2554 32.4395 23.4505C32.5193 23.6455 32.6379 23.823 32.7883 23.9727C32.9386 24.1224 33.1178 24.2413 33.3154 24.3224C33.513 24.4035 33.7251 24.4453 33.9392 24.4453C34.1534 24.4453 34.3655 24.4035 34.563 24.3224C34.7606 24.2413 34.9398 24.1224 35.0902 23.9727C35.2406 23.823 35.3591 23.6455 35.439 23.4505C35.5189 23.2554 35.5584 23.0467 35.5554 22.8365V11.1033C35.5554 8.49403 33.3655 6.34475 30.7069 6.34475C30.1302 6.34475 29.5826 6.46127 29.0676 6.64629C28.9427 4.14267 26.8218 2.11492 24.2423 2.11492C23.456 2.11492 22.7409 2.34646 22.0811 2.67875C21.2836 1.11241 19.6683 0 17.7777 0ZM4.84846 19.0342C2.18989 19.0342 0 21.1835 0 23.7928V31.195C0 38.0244 3.55038 41.761 7.56099 43.2525C11.5716 44.7439 15.9573 44.4132 18.2007 44.4132H23.0954C26.4138 44.4427 29.4962 43.4322 31.7865 41.5093C34.0767 39.5865 35.5245 36.7238 35.5554 33.3781C35.5554 33.3733 35.5554 33.3684 35.5554 33.3636V31.6122C35.5584 31.402 35.5189 31.1933 35.439 30.9983C35.3591 30.8032 35.2406 30.6257 35.0902 30.476C34.9398 30.3263 34.7606 30.2075 34.563 30.1263C34.3655 30.0452 34.1534 30.0034 33.9392 30.0034C33.7251 30.0034 33.513 30.0452 33.3154 30.1263C33.1178 30.2075 32.9386 30.3263 32.7883 30.476C32.6379 30.6257 32.5193 30.8032 32.4395 30.9983C32.3596 31.1933 32.3201 31.402 32.3231 31.6122V33.3492C32.3001 35.8438 31.3091 37.7367 29.6863 39.0991C28.0636 40.4615 25.7572 41.2642 23.1249 41.2408C23.12 41.2408 23.1151 41.2408 23.1102 41.2408H18.2007C15.712 41.2408 11.8041 41.4388 8.70577 40.2867C5.60746 39.1345 3.23231 37.0551 3.23231 31.195V23.7928C3.23231 22.8977 3.93641 22.2066 4.84846 22.2066C5.76051 22.2066 6.46462 22.8977 6.46462 23.7928V24.8503C6.4641 24.9388 6.47114 25.0272 6.48566 25.1146C6.47054 25.2054 6.4635 25.2973 6.46462 25.3893V29.4167C6.46159 29.6269 6.50115 29.8356 6.58101 30.0307C6.66087 30.2257 6.77944 30.4032 6.92981 30.5529C7.08018 30.7026 7.25937 30.8215 7.45696 30.9026C7.65454 30.9837 7.86659 31.0255 8.08077 31.0255C8.29495 31.0255 8.507 30.9837 8.70458 30.9026C8.90217 30.8215 9.08136 30.7026 9.23173 30.5529C9.38211 30.4032 9.50067 30.2257 9.58053 30.0307C9.66039 29.8356 9.69995 29.6269 9.69692 29.4167V25.3893C9.69744 25.3008 9.6904 25.2123 9.67588 25.1249C9.691 25.0342 9.69804 24.9422 9.69692 24.8503V23.7928C9.69692 21.1835 7.50704 19.0342 4.84846 19.0342ZM18.5058 25.1993C16.04 25.1993 14.0088 27.1957 14.0088 29.615C14.0088 32.0149 15.4299 33.8907 16.8497 35.1667C17.5596 35.8046 18.2898 36.3083 18.9582 36.6744C19.6267 37.0404 20.0381 37.3415 21.0121 37.3415C22.0721 37.3415 22.4473 36.9946 23.1102 36.6021C23.773 36.2096 24.4944 35.6811 25.1935 35.0304C26.5917 33.7288 28.0154 31.922 28.0154 29.615C28.0154 27.1957 25.9821 25.1993 23.5163 25.1993C22.5732 25.1993 21.7372 25.5387 21.01 26.0316C20.2828 25.539 19.4484 25.1993 18.5058 25.1993ZM18.5058 28.3717C18.99 28.3717 19.3884 28.6257 19.6064 29.0016C19.7474 29.2451 19.9516 29.4477 20.1982 29.5886C20.4448 29.7296 20.7251 29.804 21.0104 29.8042C21.2958 29.8044 21.5762 29.7304 21.823 29.5898C22.0699 29.4492 22.2743 29.247 22.4157 29.0037C22.6355 28.6256 23.0322 28.3717 23.5163 28.3717C24.2354 28.3717 24.7831 28.9085 24.7831 29.615C24.7831 30.4931 24.014 31.757 22.9692 32.7296C22.4467 33.2158 21.8826 33.6249 21.4414 33.8861C21.2812 33.981 21.1233 34.0382 20.9932 34.0803C20.862 34.0406 20.7072 33.9973 20.5344 33.9027C20.0988 33.6641 19.5456 33.2885 19.034 32.8287C18.0107 31.9091 17.2411 30.7142 17.2411 29.615C17.2411 28.9085 17.7867 28.3717 18.5058 28.3717Z" fill="#231F20"/> </svg>' },
      { value: 'Innovation Lab', label: 'Innovation Lab', icon: '<svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.22764 4.51908C3.11706 4.51978 3.00942 4.5549 2.91962 4.61959C2.82981 4.68428 2.76227 4.77534 2.72634 4.88018C2.69041 4.98502 2.68786 5.09846 2.71905 5.20482C2.75024 5.31117 2.81362 5.40519 2.90043 5.47386L4.56985 6.82977C4.62412 6.87565 4.68697 6.9102 4.75473 6.93142C4.82248 6.95264 4.89378 6.96009 4.96445 6.95334C5.03512 6.94659 5.10373 6.92578 5.16627 6.89211C5.22881 6.85845 5.28402 6.81261 5.32867 6.75729C5.37332 6.70197 5.40651 6.63828 5.42629 6.56994C5.44608 6.5016 5.45206 6.42999 5.44389 6.3593C5.43572 6.28862 5.41357 6.22027 5.37872 6.15828C5.34387 6.09628 5.29703 6.04188 5.24095 5.99826L3.57153 4.64235C3.47493 4.56199 3.35317 4.51835 3.22764 4.51908ZM22.4093 4.51908C22.2892 4.52194 22.1735 4.56538 22.0811 4.64235L20.4116 5.99826C20.3555 6.04188 20.3087 6.09628 20.2739 6.15828C20.239 6.22027 20.2169 6.28862 20.2087 6.3593C20.2005 6.42999 20.2065 6.5016 20.2263 6.56994C20.2461 6.63828 20.2793 6.70197 20.3239 6.7573C20.3686 6.81262 20.4238 6.85845 20.4863 6.89212C20.5488 6.92578 20.6175 6.9466 20.6881 6.95334C20.7588 6.96009 20.8301 6.95264 20.8979 6.93142C20.9656 6.9102 21.0285 6.87565 21.0827 6.82977L22.7522 5.47386C22.8401 5.40437 22.9039 5.30893 22.9348 5.20103C22.9656 5.09314 22.9617 4.97827 22.9238 4.87267C22.8859 4.76708 22.8158 4.67612 22.7235 4.61266C22.6311 4.5492 22.5212 4.51646 22.4093 4.51908ZM13.017 4.82724C12.6801 4.81977 12.3464 4.83351 12.0176 4.86798C8.07292 5.2817 4.82308 8.6229 4.82308 12.7047C4.82308 14.9925 5.64847 16.418 6.54252 17.6217C7.43657 18.8253 8.36399 19.8304 8.84657 21.5358C8.86418 21.605 8.89544 21.67 8.93851 21.7269C8.98158 21.7838 9.03558 21.8315 9.09732 21.8671C9.15906 21.9028 9.2273 21.9257 9.29801 21.9344C9.36872 21.9432 9.44047 21.9377 9.50902 21.9183C9.57758 21.8988 9.64155 21.8658 9.69716 21.8211C9.75277 21.7765 9.7989 21.7211 9.83283 21.6583C9.86676 21.5955 9.88779 21.5265 9.89469 21.4554C9.9016 21.3843 9.89423 21.3126 9.87302 21.2444C9.32212 19.2974 8.24829 18.1256 7.39911 16.9824C6.54993 15.8391 5.89017 14.7474 5.89017 12.7047C5.89017 8.01927 10.8369 4.40254 15.6774 6.49341C18.3543 7.64967 19.9483 10.3433 19.7426 13.2792C19.5969 15.3607 18.647 16.4285 17.6115 17.7731C16.5761 19.1178 15.494 20.7348 15.494 23.5405V26.2147C15.494 27.1071 14.7836 27.8192 13.8934 27.8192H11.7592C10.869 27.8192 10.1586 27.1071 10.1586 26.2147V24.0753H11.7592C11.833 24.0753 11.906 24.0599 11.9736 24.0301C12.0412 24.0003 12.1019 23.9568 12.1518 23.9023C12.2018 23.8478 12.2399 23.7836 12.2638 23.7135C12.2877 23.6435 12.2968 23.5693 12.2907 23.4955C11.8112 17.7286 9.85392 14.5254 9.33739 13.7253C9.44949 13.6925 9.44257 13.7241 9.56873 13.6699C9.99241 13.4879 10.4914 13.0964 10.9714 12.5543C11.3456 12.9331 11.9128 13.3785 12.8263 13.3785C13.7398 13.3785 14.3069 12.9331 14.6812 12.5543C15.1612 13.0964 15.6602 13.4879 16.0838 13.6699C16.21 13.7241 16.2031 13.6925 16.3152 13.7253C15.7987 14.5254 13.8413 17.7286 13.3619 23.4955C13.3537 23.5667 13.3599 23.6388 13.38 23.7075C13.4001 23.7762 13.4338 23.8402 13.4791 23.8956C13.5243 23.9511 13.5802 23.9968 13.6435 24.0302C13.7067 24.0635 13.776 24.0838 13.8472 24.0898C13.9184 24.0959 13.9901 24.0875 14.058 24.0652C14.1259 24.0429 14.1886 24.0072 14.2425 23.9602C14.2964 23.9131 14.3403 23.8557 14.3716 23.7913C14.4029 23.7269 14.421 23.6569 14.4248 23.5854C14.9476 17.2971 17.5292 13.6898 17.5292 13.6898C17.5863 13.6098 17.6203 13.5155 17.6274 13.4174C17.6346 13.3193 17.6146 13.2211 17.5697 13.1337C17.5248 13.0462 17.4567 12.9729 17.3729 12.9217C17.2891 12.8705 17.1928 12.8435 17.0947 12.8436C17.0947 12.8436 16.8872 12.8501 16.5049 12.6859C16.1226 12.5216 15.6143 12.1939 15.1376 11.4773C15.0903 11.406 15.0266 11.3472 14.9519 11.3058C14.8771 11.2644 14.7936 11.2415 14.7082 11.2392C14.6229 11.2368 14.5382 11.255 14.4613 11.2923C14.3845 11.3295 14.3176 11.3847 14.2665 11.4532C14.2665 11.4532 13.5391 12.3088 12.8263 12.3088C12.1135 12.3088 11.3861 11.4532 11.3861 11.4532C11.3349 11.3847 11.2681 11.3295 11.1912 11.2923C11.1144 11.255 11.0297 11.2368 10.9443 11.2392C10.859 11.2415 10.7754 11.2644 10.7007 11.3058C10.626 11.3472 10.5623 11.406 10.5149 11.4773C10.0383 12.1939 9.53003 12.5216 9.14773 12.6859C8.76543 12.8501 8.55791 12.8436 8.55791 12.8436C8.45978 12.8435 8.36353 12.8705 8.27972 12.9217C8.19592 12.9729 8.12782 13.0462 8.0829 13.1337C8.03799 13.2211 8.018 13.3193 8.02514 13.4174C8.03228 13.5155 8.06626 13.6098 8.12336 13.6898C8.12336 13.6898 10.4943 17.1141 11.1308 23.0056H9.625C9.4835 23.0056 9.3478 23.062 9.24774 23.1623C9.14769 23.2626 9.09147 23.3986 9.09146 23.5405V26.2147C9.09146 27.6852 10.2922 28.8889 11.7592 28.8889H13.8934C15.3604 28.8889 16.5611 27.6852 16.5611 26.2147V23.5405C16.5611 20.9977 17.4466 19.7388 18.4567 18.4271C19.4667 17.1153 20.6402 15.7458 20.8076 13.3544C21.0437 9.98455 19.1902 6.8465 16.0995 5.51147C15.0685 5.06614 14.0277 4.84967 13.017 4.82724ZM0.541147 12.3088C0.470445 12.3078 0.40025 12.3209 0.334641 12.3473C0.269031 12.3737 0.209316 12.413 0.158965 12.4627C0.108615 12.5125 0.0686327 12.5718 0.041343 12.6372C0.0140532 12.7026 0 12.7727 0 12.8436C0 12.9145 0.0140532 12.9847 0.041343 13.0501C0.0686327 13.1154 0.108615 13.1747 0.158965 13.2245C0.209316 13.2743 0.269031 13.3135 0.334641 13.3399C0.40025 13.3664 0.470445 13.3795 0.541147 13.3785H2.68888C2.75959 13.3795 2.82978 13.3664 2.89539 13.3399C2.961 13.3135 3.02072 13.2743 3.07107 13.2245C3.12142 13.1747 3.1614 13.1154 3.18869 13.0501C3.21598 12.9847 3.23003 12.9145 3.23003 12.8436C3.23003 12.7727 3.21598 12.7026 3.18869 12.6372C3.1614 12.5718 3.12142 12.5125 3.07107 12.4627C3.02072 12.413 2.961 12.3737 2.89539 12.3473C2.82978 12.3209 2.75959 12.3078 2.68888 12.3088H0.541147ZM22.9637 12.3088C22.893 12.3078 22.8228 12.3209 22.7572 12.3473C22.6916 12.3737 22.6319 12.413 22.5815 12.4627C22.5312 12.5125 22.4912 12.5718 22.4639 12.6372C22.4366 12.7026 22.4225 12.7727 22.4225 12.8436C22.4225 12.9145 22.4366 12.9847 22.4639 13.0501C22.4912 13.1154 22.5312 13.1747 22.5815 13.2245C22.6319 13.2743 22.6916 13.3135 22.7572 13.3399C22.8228 13.3664 22.893 13.3795 22.9637 13.3785H25.1114C25.1821 13.3795 25.2523 13.3664 25.3179 13.3399C25.3835 13.3135 25.4433 13.2743 25.4936 13.2245C25.544 13.1747 25.5839 13.1154 25.6112 13.0501C25.6385 12.9847 25.6526 12.9145 25.6526 12.8436C25.6526 12.7727 25.6385 12.7026 25.6112 12.6372C25.5839 12.5718 25.544 12.5125 25.4936 12.4627C25.4433 12.413 25.3835 12.3737 25.3179 12.3473C25.2523 12.3209 25.1821 12.3078 25.1114 12.3088H22.9637ZM4.89811 18.7342C4.77796 18.7371 4.6623 18.7805 4.56985 18.8575L2.90043 20.2134C2.84434 20.257 2.79751 20.3114 2.76266 20.3734C2.72781 20.4354 2.70565 20.5037 2.69748 20.5744C2.68931 20.6451 2.6953 20.7167 2.71508 20.785C2.73487 20.8534 2.76805 20.9171 2.8127 20.9724C2.85735 21.0277 2.91256 21.0736 2.97511 21.1072C3.03765 21.1409 3.10626 21.1617 3.17693 21.1684C3.24759 21.1752 3.31889 21.1677 3.38665 21.1465C3.45441 21.1253 3.51726 21.0907 3.57153 21.0449L5.24095 19.689C5.32886 19.6195 5.39275 19.524 5.42355 19.4161C5.45436 19.3083 5.45054 19.1934 5.41262 19.0878C5.3747 18.9822 5.30462 18.8912 5.21228 18.8278C5.11994 18.7643 5.01003 18.7316 4.89811 18.7342ZM20.7388 18.7342C20.6283 18.7349 20.5206 18.77 20.4308 18.8347C20.341 18.8994 20.2735 18.9904 20.2375 19.0953C20.2016 19.2001 20.1991 19.3136 20.2303 19.4199C20.2614 19.5263 20.3248 19.6203 20.4116 19.689L22.0811 21.0449C22.1353 21.0907 22.1982 21.1253 22.2659 21.1465C22.3337 21.1677 22.405 21.1752 22.4757 21.1684C22.5463 21.1617 22.6149 21.1409 22.6775 21.1072C22.74 21.0736 22.7952 21.0277 22.8399 20.9724C22.8845 20.9171 22.9177 20.8534 22.9375 20.785C22.9573 20.7167 22.9633 20.6451 22.9551 20.5744C22.9469 20.5037 22.9248 20.4354 22.8899 20.3734C22.8551 20.3114 22.8082 20.257 22.7522 20.2134L21.0827 18.8575C20.9861 18.7771 20.8644 18.7335 20.7388 18.7342Z" fill="#231F20"/> <path d="M12.369 0.550537C12.365 0.430307 12.4017 0.312338 12.4732 0.215735C12.5398 0.12577 12.6332 0.0590944 12.7399 0.0251497C12.8467 -0.00879499 12.9615 -0.0082913 13.0682 0.0265907C13.1748 0.0614727 13.2678 0.128967 13.3341 0.219516C13.4004 0.310065 13.4365 0.419083 13.4374 0.531138L13.4831 2.68134C13.486 2.75234 13.4747 2.82317 13.4499 2.88969C13.425 2.9562 13.3871 3.01706 13.3384 3.06871C13.2897 3.12035 13.2312 3.16174 13.1662 3.19045C13.1012 3.21916 13.0312 3.23461 12.9601 3.2359C12.889 3.23719 12.8184 3.2243 12.7523 3.19797C12.6862 3.17164 12.626 3.13241 12.5752 3.08257C12.5244 3.03273 12.484 2.97329 12.4565 2.90772C12.4289 2.84216 12.4147 2.77179 12.4147 2.70074L12.369 0.550537Z" fill="#231F20"/> </svg>' },
      { value: 'National Yarchei Kallah', label: 'National Yarchei Kallah', icon: '<svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.40387 0.000110486C5.11018 -0.0124916 5.72859 1.05602 5.99963 1.63213C6.95087 3.65443 7.36621 5.64643 5.10936 6.78786L5.09498 7.57752C6.1547 7.56259 7.18094 7.49306 7.27783 8.90992C7.35701 10.0668 7.31385 11.2376 7.31341 12.3988L7.3109 19.4592C8.59949 19.7951 9.57989 20.5694 9.56082 21.9835C9.52569 24.5759 6.94201 24.4161 5.24167 24.3922C4.31705 24.3966 3.41011 24.4293 2.46228 24.3886C0.318501 24.2967 -0.753632 22.0861 0.600068 20.3837C1.04331 19.826 1.51529 19.6687 2.19548 19.5043C2.23376 18.0127 1.98908 8.82134 2.38836 8.19873C2.72381 7.67571 3.56919 7.56799 4.1243 7.45061C4.51632 6.52006 3.32948 6.56756 2.94579 6.07046C1.56295 4.2791 3.03406 1.33282 4.40387 0.000110486ZM7.43421 23.3748C9.65336 22.3787 8.49936 20.2609 6.21053 20.4713C4.94576 20.588 3.30766 20.4236 1.97728 20.5323C-0.0858939 21.7052 1.12677 23.5895 3.29277 23.4172C4.56816 23.3155 6.10679 23.4853 7.43421 23.3748ZM6.12624 8.69188C5.60641 8.45041 4.40918 8.53159 3.80412 8.54299C3.4286 8.59611 3.46397 8.52902 3.2419 8.74274C3.11735 9.39987 3.1684 11.6034 3.16902 12.3643L3.19092 19.5062C4.11055 19.5265 5.0304 19.5291 5.95012 19.5132L6.2119 19.4814C6.45262 19.0086 6.4047 9.13615 6.12624 8.69188ZM4.54896 1.3011C3.83151 2.31393 3.21919 3.64946 3.39543 4.9263C3.48076 5.54475 4.02752 5.84237 4.60919 5.68248C6.90223 6.03039 5.33824 1.73671 4.54896 1.3011Z" fill="#231F20"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3491 0.00215281C16.0756 -0.00359241 16.669 1.0354 16.9512 1.6306C17.8993 3.63046 18.3219 5.6814 16.0415 6.76954L16.0404 6.77058L16.0444 7.57117C16.9592 7.58354 18.1328 7.45852 18.2339 8.77343C18.3305 10.0312 18.2834 11.3383 18.2796 12.6053L18.277 19.4788C20.2781 19.9357 21.328 21.8193 19.8868 23.6179C19.1365 24.5549 17.4921 24.4072 16.3807 24.3975C14.6236 24.4169 11.6522 24.858 11.0841 22.5909C10.928 21.9492 11.0314 21.2713 11.3714 20.7074C11.8512 19.9251 12.3587 19.7032 13.1966 19.5088L13.1903 12.454C13.1843 11.1981 13.1544 9.93458 13.1994 8.68081C13.233 7.74701 14.3496 7.60704 15.0508 7.46474C15.5584 6.64108 14.2035 6.45828 13.9152 6.09678C12.4757 4.29226 13.9755 1.37499 15.3491 0.00215281ZM18.486 23.3421C20.4509 22.4574 19.6107 20.3697 17.5149 20.4722C16.028 20.5455 14.444 20.4121 12.9396 20.5385C11.3119 21.5602 11.9025 23.3112 13.4226 23.3731C14.7953 23.4297 17.1495 23.526 18.486 23.3421ZM17.1861 8.72349C16.7544 8.45511 15.8187 8.53368 15.2851 8.54331C14.9296 8.55568 14.5189 8.55947 14.1693 8.58404L14.1553 19.5122L16.3746 19.5167L17.3091 19.5149C17.3109 18.1594 17.4395 9.37615 17.1861 8.72349ZM15.4775 1.29819C14.8165 2.28124 14.1515 3.5876 14.3061 4.81363C14.392 5.49577 14.9419 5.81063 15.5811 5.69396C17.8114 5.9415 16.2879 1.67013 15.4775 1.29819Z" fill="#231F20"/> </svg>' },
      { value: 'Ben Zakkai Honor Society', label: 'Ben Zakkai Honor Society', icon: '<svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.25813 0C6.03155 0 5.82565 0.123507 5.72266 0.329485C5.61967 0.535463 5.61959 0.782959 5.74318 0.96834C6.29933 1.79225 6.95847 2.55413 7.70001 3.19267V7.29172C7.70001 10.2372 10.11 12.6472 13.0556 12.6472C16.0011 12.6472 18.4111 10.2372 18.4111 7.29172V4.98492C18.2669 2.20421 15.9804 0 13.1791 0H6.25813ZM8.9359 4.16101C10.8309 5.43807 13.0554 6.1178 15.3624 6.1178C15.9597 6.1178 16.5779 6.07636 17.1752 5.97337V7.29172C17.1752 9.55748 15.3214 11.4113 13.0556 11.4113C10.7897 11.4113 8.9359 9.55748 8.9359 7.29172V4.16101ZM6.32049 4.69245C6.27922 4.69603 6.23738 4.70411 6.19618 4.71699C4.34234 5.21133 3.06541 6.87992 3.06541 8.79552C3.06541 11.1643 4.96045 13.0386 7.28805 13.0386C7.8236 13.0386 8.35907 12.9356 8.85343 12.7296C9.16241 12.606 9.32743 12.2352 9.20384 11.9262C9.08025 11.6173 8.70941 11.4526 8.40043 11.5762C8.05026 11.7204 7.67941 11.7822 7.28805 11.7822C5.64019 11.7822 4.3013 10.4433 4.3013 8.79552C4.3013 7.43606 5.20779 6.26199 6.52607 5.91182C6.85564 5.82943 7.06155 5.47903 6.95855 5.14946C6.88646 4.86109 6.60943 4.66738 6.32049 4.69245ZM19.6888 4.7198C19.4038 4.70854 19.1422 4.90253 19.0701 5.1909C18.9877 5.52046 19.1939 5.84995 19.5235 5.93234C20.883 6.24131 21.8098 7.4359 21.8098 8.83655C21.8098 10.4638 20.4709 11.8027 18.8231 11.8027C18.4317 11.8027 18.0608 11.7409 17.7107 11.5967C17.4017 11.4732 17.0309 11.6172 16.9073 11.9467C16.7837 12.2557 16.9281 12.6266 17.2577 12.7501C17.752 12.9561 18.2875 13.0591 18.8231 13.0591C21.1507 13.0591 23.0457 11.1641 23.0457 8.83655C23.0457 6.87976 21.707 5.19066 19.8119 4.7375C19.7707 4.7272 19.7295 4.72141 19.6888 4.7198ZM13.0556 13.7595C9.67744 13.7595 6.54667 15.5926 4.87821 18.5175C4.71343 18.8059 4.81634 19.1972 5.10471 19.362C5.20771 19.4238 5.3107 19.4444 5.41369 19.4444C5.61967 19.4444 5.84617 19.3415 5.94916 19.1355C7.39104 16.5813 10.11 14.9954 13.0556 14.9954C15.9805 14.9954 18.6995 16.5813 20.1619 19.1355C20.3267 19.4238 20.718 19.5268 21.0064 19.362C21.2948 19.1972 21.3977 18.8265 21.2329 18.5175C19.5644 15.5926 16.4337 13.7595 13.0556 13.7595ZM5.18759 14.606C5.14631 14.6081 5.10447 14.6142 5.06328 14.6245C2.96226 15.2218 1.14977 16.6431 0.0786636 18.5175C-0.0861223 18.8059 0.0167885 19.1972 0.305164 19.362C0.408155 19.4238 0.511146 19.4444 0.614137 19.4444C0.82012 19.4444 1.04662 19.3415 1.14961 19.1355C2.05593 17.5288 3.60112 16.3137 5.39317 15.8193C5.72274 15.7369 5.90805 15.3865 5.82565 15.0569C5.75356 14.7686 5.47653 14.5908 5.18759 14.606ZM20.9235 14.606C20.6346 14.5908 20.3575 14.7686 20.2855 15.0569C20.2031 15.3865 20.3884 15.7369 20.7179 15.8193C22.4894 16.3137 24.0346 17.5288 24.9615 19.1355C25.0851 19.3415 25.291 19.4444 25.497 19.4444C25.6 19.4444 25.703 19.4238 25.8059 19.362C26.0943 19.1972 26.1972 18.8265 26.0324 18.5175C24.9613 16.6225 23.1489 15.2012 21.0478 14.6245C21.0066 14.6142 20.9648 14.6081 20.9235 14.606Z" fill="#231F20"/> </svg>' },
    ]

    // Hand icon reused for the renamed "NCSY Programs" card (formerly General Donation)
    const programsIcon = '<svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17.7777 0C15.8871 0 14.2718 1.11241 13.4743 2.67875C12.8145 2.34646 12.0994 2.11492 11.3131 2.11492C8.6545 2.11492 6.46462 4.2642 6.46462 6.87347V14.3996C6.46159 14.6098 6.50115 14.8185 6.58101 15.0135C6.66087 15.2086 6.77944 15.3861 6.92981 15.5358C7.08018 15.6855 7.25937 15.8043 7.45696 15.8855C7.65454 15.9666 7.86659 16.0084 8.08077 16.0084C8.29495 16.0084 8.507 15.9666 8.70458 15.8855C8.90217 15.8043 9.08136 15.6855 9.23173 15.5358C9.38211 15.3861 9.50067 15.2086 9.58053 15.0135C9.66039 14.8185 9.69995 14.6098 9.69692 14.3996V6.87347C9.69692 5.97834 10.401 5.28729 11.3131 5.28729C12.2251 5.28729 12.9292 5.97834 12.9292 6.87347V20.6204C12.9262 20.8306 12.9658 21.0393 13.0456 21.2343C13.1255 21.4294 13.2441 21.6069 13.3944 21.7566C13.5448 21.9063 13.724 22.0252 13.9216 22.1063C14.1192 22.1874 14.3312 22.2292 14.5454 22.2292C14.7596 22.2292 14.9716 22.1874 15.1692 22.1063C15.3668 22.0252 15.546 21.9063 15.6963 21.7566C15.8467 21.6069 15.9653 21.4294 16.0451 21.2343C16.125 21.0393 16.1646 20.8306 16.1615 20.6204V4.75856C16.1615 3.86342 16.8656 3.17237 17.7777 3.17237C18.6897 3.17237 19.3938 3.86342 19.3938 4.75856V20.6204C19.3908 20.8306 19.4304 21.0393 19.5102 21.2343C19.5901 21.4294 19.7087 21.6069 19.859 21.7566C20.0094 21.9063 20.1886 22.0252 20.3862 22.1063C20.5838 22.1874 20.7958 22.2292 21.01 22.2292C21.2242 22.2292 21.4362 22.1874 21.6338 22.1063C21.8314 22.0252 22.0106 21.9063 22.161 21.7566C22.3113 21.6069 22.4299 21.4294 22.5098 21.2343C22.5896 21.0393 22.6292 20.8306 22.6262 20.6204V6.87347C22.6262 5.97834 23.3303 5.28729 24.2423 5.28729C25.1544 5.28729 25.8585 5.97834 25.8585 6.87347V19.563C25.8554 19.7732 25.895 19.9818 25.9749 20.1769C26.0547 20.3719 26.1733 20.5495 26.3237 20.6992C26.474 20.8488 26.6532 20.9677 26.8508 21.0488C27.0484 21.13 27.2604 21.1717 27.4746 21.1717C27.6888 21.1717 27.9008 21.13 28.0984 21.0488C28.296 20.9677 28.4752 20.8488 28.6256 20.6992C28.776 20.5495 28.8945 20.3719 28.9744 20.1769C29.0542 19.9818 29.0938 19.7732 29.0908 19.563V11.1033C29.0908 10.2082 29.7949 9.51712 30.7069 9.51712C31.619 9.51712 32.3231 10.2082 32.3231 11.1033V22.8365C32.3201 23.0467 32.3596 23.2554 32.4395 23.4505C32.5193 23.6455 32.6379 23.823 32.7883 23.9727C32.9386 24.1224 33.1178 24.2413 33.3154 24.3224C33.513 24.4035 33.7251 24.4453 33.9392 24.4453C34.1534 24.4453 34.3655 24.4035 34.563 24.3224C34.7606 24.2413 34.9398 24.1224 35.0902 23.9727C35.2406 23.823 35.3591 23.6455 35.439 23.4505C35.5189 23.2554 35.5584 23.0467 35.5554 22.8365V11.1033C35.5554 8.49403 33.3655 6.34475 30.7069 6.34475C30.1302 6.34475 29.5826 6.46127 29.0676 6.64629C28.9427 4.14267 26.8218 2.11492 24.2423 2.11492C23.456 2.11492 22.7409 2.34646 22.0811 2.67875C21.2836 1.11241 19.6683 0 17.7777 0ZM4.84846 19.0342C2.18989 19.0342 0 21.1835 0 23.7928V31.195C0 38.0244 3.55038 41.761 7.56099 43.2525C11.5716 44.7439 15.9573 44.4132 18.2007 44.4132H23.0954C26.4138 44.4427 29.4962 43.4322 31.7865 41.5093C34.0767 39.5865 35.5245 36.7238 35.5554 33.3781C35.5554 33.3733 35.5554 33.3684 35.5554 33.3636V31.6122C35.5584 31.402 35.5189 31.1933 35.439 30.9983C35.3591 30.8032 35.2406 30.6257 35.0902 30.476C34.9398 30.3263 34.7606 30.2075 34.563 30.1263C34.3655 30.0452 34.1534 30.0034 33.9392 30.0034C33.7251 30.0034 33.513 30.0452 33.3154 30.1263C33.1178 30.2075 32.9386 30.3263 32.7883 30.476C32.6379 30.6257 32.5193 30.8032 32.4395 30.9983C32.3596 31.1933 32.3201 31.402 32.3231 31.6122V33.3492C32.3001 35.8438 31.3091 37.7367 29.6863 39.0991C28.0636 40.4615 25.7572 41.2642 23.1249 41.2408C23.12 41.2408 23.1151 41.2408 23.1102 41.2408H18.2007C15.712 41.2408 11.8041 41.4388 8.70577 40.2867C5.60746 39.1345 3.23231 37.0551 3.23231 31.195V23.7928C3.23231 22.8977 3.93641 22.2066 4.84846 22.2066C5.76051 22.2066 6.46462 22.8977 6.46462 23.7928V24.8503C6.4641 24.9388 6.47114 25.0272 6.48566 25.1146C6.47054 25.2054 6.4635 25.2973 6.46462 25.3893V29.4167C6.46159 29.6269 6.50115 29.8356 6.58101 30.0307C6.66087 30.2257 6.77944 30.4032 6.92981 30.5529C7.08018 30.7026 7.25937 30.8215 7.45696 30.9026C7.65454 30.9837 7.86659 31.0255 8.08077 31.0255C8.29495 31.0255 8.507 30.9837 8.70458 30.9026C8.90217 30.8215 9.08136 30.7026 9.23173 30.5529C9.38211 30.4032 9.50067 30.2257 9.58053 30.0307C9.66039 29.8356 9.69995 29.6269 9.69692 29.4167V25.3893C9.69744 25.3008 9.6904 25.2123 9.67588 25.1249C9.691 25.0342 9.69804 24.9422 9.69692 24.8503V23.7928C9.69692 21.1835 7.50704 19.0342 4.84846 19.0342ZM18.5058 25.1993C16.04 25.1993 14.0088 27.1957 14.0088 29.615C14.0088 32.0149 15.4299 33.8907 16.8497 35.1667C17.5596 35.8046 18.2898 36.3083 18.9582 36.6744C19.6267 37.0404 20.0381 37.3415 21.0121 37.3415C22.0721 37.3415 22.4473 36.9946 23.1102 36.6021C23.773 36.2096 24.4944 35.6811 25.1935 35.0304C26.5917 33.7288 28.0154 31.922 28.0154 29.615C28.0154 27.1957 25.9821 25.1993 23.5163 25.1993C22.5732 25.1993 21.7372 25.5387 21.01 26.0316C20.2828 25.539 19.4484 25.1993 18.5058 25.1993ZM18.5058 28.3717C18.99 28.3717 19.3884 28.6257 19.6064 29.0016C19.7474 29.2451 19.9516 29.4477 20.1982 29.5886C20.4448 29.7296 20.7251 29.804 21.0104 29.8042C21.2958 29.8044 21.5762 29.7304 21.823 29.5898C22.0699 29.4492 22.2743 29.247 22.4157 29.0037C22.6355 28.6256 23.0322 28.3717 23.5163 28.3717C24.2354 28.3717 24.7831 28.9085 24.7831 29.615C24.7831 30.4931 24.014 31.757 22.9692 32.7296C22.4467 33.2158 21.8826 33.6249 21.4414 33.8861C21.2812 33.981 21.1233 34.0382 20.9932 34.0803C20.862 34.0406 20.7072 33.9973 20.5344 33.9027C20.0988 33.6641 19.5456 33.2885 19.034 32.8287C18.0107 31.9091 17.2411 30.7142 17.2411 29.615C17.2411 28.9085 17.7867 28.3717 18.5058 28.3717Z" fill="#231F20"/> </svg>'
    const designationCards = [
      { value: 'NCSY Programs', label: 'NCSY Programs', icon: programsIcon },
      ...designations.filter((d) => d.value === 'NCSY Region' || d.value === 'NCSY Summer'),
    ]

    const state = ref(false)
    const selected = ref(false)
    const customSelected = ref(false);
    const currentStep = ref(1)

    if (params.amount) {
      nextTick(() => setValue('amount', params.amount))
      // If amount provided via URL params, skip to step 2 (Personal Info)
      currentStep.value = 2
    }

    if (params.inHonorOf === 'true') {
      inHonorOf.value = true
    }

    if (params.dayOfMonth) {
      nextTick(() => setValue('dayOfMonth', params.dayOfMonth))
    }

    if (params.periodMonths) {
      nextTick(() => setValue('periodMonths', params.periodMonths))
      // periodMonths only applies to monthly giving, so default dayOfMonth
      // to today if it wasn't explicitly provided in the URL
      if (!params.dayOfMonth) {
        nextTick(() => setValue('dayOfMonth', '' + new Date().getDate()))
      }
    }

    if (params.handleProcessing === 'true') {
      nextTick(() => setValue('handleProcessing', true))
    }

    // Default to NCSY Programs / General Donation when no designation is provided
    nextTick(() => {
      if (!getValue('custom.designation')) {
        setValue('custom.designation', 'NCSY Programs')
        setValue('custom.programType', 'General Donation')
      }
    })
    const steps = [
      'Donation Amount',
      'Your Info & Payment',
    ]

    const validateAndNext = () => {
      // Touch all fields to trigger error display
      const fieldsToValidate = ['firstName', 'lastName', 'email', 'country', 'city', 'street', 'state', 'zip', 'phone'] as const
      
      fieldsToValidate.forEach(field => {
        setTouched(field as any)
      })

      // Check if there are any errors before proceeding
      if (Object.keys(errors.value).length === 0) {
        currentStep.value = 3
      }
    }

    // State selector logic
    watch(
      () => form.value.country,
      () => setValue('state', null)
    );

    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "NCSY Programs" || !val) {
          const pt = getValue("custom.programType") || "General Donation";
          if (!getValue("custom.programType")) {
            setValue("custom.programType", "General Donation");
          }
          if (pt == "JSU") {
            setValue("applications.0.department", "NCSY");
            setValue("applications.0.campaign", "JSU Donation");
          } else if (pt == "Gift of Yeshiva") {
            setValue("applications.0.department", "NCSY");
            setValue("applications.0.campaign", "Gift of Yeshiva");
          } else if (pt == "Ben Zakkai") {
            setValue("applications.0.department", "BenZakkai");
            setValue("applications.0.campaign", "General Donation");
          } else {
            setValue("applications.0.department", "NCSY");
            setValue("applications.0.campaign", "General Donation");
          }
        }
        else if (val == "Ben Zakkai Honor Society") {
          setValue("applications.0.department", "BenZakkai");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Yarchei Kallah" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Yarchei Kallah");
        } 
         else if(val == "JSU Expansion" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "JSU Expansion");
        } 
         else if(val == "NCSY Summer" || !val) {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Education Donation" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Education Donation");
        } 
        else if(val == "Innovation Lab" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Innovation Lab");
        } 
        else {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "General Donation");
          // setValue("applications.0.campaign", val);
        }
      }
    );

    watch(
      () => getValue("custom.programType"),
      (val) => {
        if (val == "JSU") {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "JSU Donation");
        } else if (val == "Gift of Yeshiva") {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Gift of Yeshiva");
        } else if (val == "Ben Zakkai") {
          setValue("applications.0.department", "BenZakkai");
          setValue("applications.0.campaign", "General Donation");
        } else {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "General Donation");
        }
      }
    );


        watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if(val == "Alumni" || !val) {
          setValue("applications.0.department", "NCSY_Alumni");
          setValue("applications.0.campaign", "General Donation");
         } 
        else if(val == "Argentina" || !val) {
          setValue("applications.0.department", "NCSY_Argentina");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Atlanta" || !val) {
          setValue("applications.0.department", "NCSY_Atlanta");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Atlantic Seaboard" || !val) {
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Canada" || !val) {
          setValue("applications.0.department", "NCSY_Canada");
          setValue("applications.0.campaign", "General Donation");
          setValue('gateway', 'SensePassCardknox')
        } 
        else if(val == "Canada Dinner" || !val) {
          setValue("applications.0.department", "NCSY_Canada");
          setValue("applications.0.campaign", "Gala Dinner");
          setValue('gateway', 'SensePassCardknox')
        } 
        else if(val == "Central East" || !val) {
          setValue("applications.0.department", "NCSY_CentralEast");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "Chile" || !val) {
          setValue("applications.0.department", "NCSY_Chile");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "Israel" || !val) {
          setValue("applications.0.department", "NCSY_Israel");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Midwest" || !val) {
          setValue("applications.0.department", "NCSY_Midwest");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Mexico" || !val) {
          setValue("applications.0.department", "NCSY_Mexico");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "National" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "General Donation");
           } 
        else if(val == "New Jersey" || !val) {
          setValue("applications.0.department", "NCSY_Tristate");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "New York" || !val) {
          setValue("applications.0.department", "NCSY_Tristate");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "New England" || !val) {
          setValue("applications.0.department", "NCSY_NewEngland");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Oregon" || !val) {
          setValue("applications.0.department", "NCSY_Portland");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Southern" || !val) {
          setValue("applications.0.department", "NCSY_Southern");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Southwest" || !val) {
          setValue("applications.0.department", "NCSY_Southwest");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "West Coast" || !val) {
          setValue("applications.0.department", "NCSY_WestCoast");
          setValue("applications.0.campaign", "General Donation");
        } 
        else {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", val);
        }
      }
    );



    const amount = computed(() => {
      const baseAmount = Number(form.value.amount) || 0
      const isHandlingProcessing = Boolean(form.value.handleProcessing)
      const gateway = form.value.gateway
      const transactionFee = Number(form.value.transactionFee) || 2.5
      
      let calculatedAmount = ['wire', 'check'].includes(String(gateway || ''))
      ? baseAmount
      : isHandlingProcessing
        ? Math.round((baseAmount + baseAmount * transactionFee / 100) * 100) / 100
        : baseAmount;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
        calculatedAmount *= Number(form.value.periodMonths);
      }

      return calculatedAmount;
    });

    const stateOptions = computed(() => {
      if (form.value.country == 'US') return states
      if (form.value.country == 'CA') return provinces
      return []
    })

    const displayDept = computed(() => {
      let raw = (form.value.applications?.[0]?.department || '').replace(/_/g, ' ')
      if (!raw) return ''
      // Expand 'AtlanticSeaboard' wherever it appears (standalone or within a longer string)
      raw = raw.replace(/AtlanticSeaboard/g, 'Atlantic Seaboard')
      return raw
    })

    const goBack = () => {
      if (currentStep.value > 1) {
        currentStep.value -= 1
      }
    }

    const stepsBar = ref<HTMLElement | null>(null)

    const goToStep = async (step: number) => {
      currentStep.value = step
      await nextTick()
      scrollToStepsBar(stepsBar.value)
    }

    return {
      processing: submitting,
      form,
      getValue,
      note,
      amount,
      steps,
      feePercent,
      finished: false,
      setValue,
      submit,
      currentStep,
      customSelected,
      selected,
      state,
      stateOptions,
      inHonorOf,
      validateAndNext,
      isDev,
      recipientFlag,
      goBack,
      stepsBar,
      goToStep,
      displayDept,
        feeTooltipOpen,
        showFeeTooltip,
        hideFeeTooltip,
        toggleFeeTooltip,
        closeFeeTooltip,
      designations,
      designationCards
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

:deep(.ou-donation-form) {
  max-width: 480px;
  background: white;
  width: 100%;
 color: var(--Grayscale-Ash, #160D10);
text-align: center;
font-family: "Albert Sans";
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 100% */
  margin: 0 auto;
  position: relative;

  transition: all 0.1s ease-in-out;
      @media only screen and (max-width: 720px) {
  
    }
&.fullwidth{

}
}
:deep(.ou-donation-form) {
  h2 {
color: var(--Grayscale-Ash, #160D10);
text-align: center;
font-family: "Albert Sans";
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 28.8px; /* 120% */
letter-spacing: -2px;
    margin-top: 0px;
    margin-bottom: 12px;
      @media only screen and (max-width: 720px) {

    }
  }

  input[type='email'],
  input[type='number'],
  input[type='password'],
  input[type='tel'],
  input[type='text'] {
display: flex;
height: 40px;
padding: 8px 12px;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 8px;
border: 1.2px solid var(--Grayscale-Line, #D3CFD0);
background: var(--Grayscale-Off-white, #FCFCFC);
box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06);

color: var(--Grayscale-Body, #494647);

/* Desktop/Text/Body 2 */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19px; /* 135.714% */
  }  
  

  textarea,
  select {
    border-radius: 8px;
border: 1.2px solid var(--Grayscale-Line, #D3CFD0);
background: var(--Grayscale-Off-white, #FCFCFC);
box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06);
color: var(--Grayscale-Body, #494647);
color: var(--Grayscale-Body, #494647);

/* Desktop/Text/Body 2 */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19px; /* 135.714% */
  }
  input[type='tel'] {
    height: 42px;
  }
}
:deep(.frequency) {
  display: flex;
  justify-content: space-between;

 
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
input[type='checkbox'] {
  margin-right: 5px;
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

:deep(.ou-donation-form .ou-donation-btn) {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
:deep(.thank-you-container .ou-donation-btn) {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.steps-bar {
  max-width: 100%;
  width: 100%;
  display: flex;
  // Host pages with a sticky header set --donation-form-scroll-offset on <donation-form>.
  scroll-margin-top: var(--donation-form-scroll-offset, 16px);
  padding-top: 20px;
  margin: 0px auto 16px;
  justify-content: space-between;
          @media only screen and (max-width: 720px) {
            margin: 0px auto 28px;
              padding-top: 0px;
          }

}
.steps-bar__item {
    display: flex;
    position: relative;
    flex: 25%;
    flex-flow: column;
    align-items: center;
    justify-content: center;

  &.steps-bar__item--last {
    flex-grow: 1;
    .steps-bar__item-dot::after{
      background: #183346;
    }
    .steps-bar__item-line {
      display: none;
    }
  }
  &.steps-bar__item--active {
    .steps-bar__item-dot {
      span{
        background: #FFF;
        border: 2px solid #FF961F;
        &::after{
          background: var(--Primary-500, #FF961F);
        }
      }
      &::after{
            background: #FF961F;
      }
    }
    .steps-bar__item-line {
      background: #FF961F;
    }
    
    &:last-child {

    }
  }  
  &.steps-bar__item--current-active {
    .steps-bar__item__text{
color: var(--Grayscale-Ash, #160D10);

    }
    .steps-bar__item-dot {
        &::after{
          background: #FF961F;
        }
      }
  }
  &.steps-bar__item--last{
    .steps-bar__item-dot{
           &::after{
          display: none !important;
          }
    } 
  }
}

.steps-bar__item__text {
    gap: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #9ABBFF;
    mix-blend-mode: normal;
    text-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    padding-bottom: 8px;
        @media only screen and (max-width: 720px) {
        max-width: 55px;
        height: 32px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #9ABBFF;
        mix-blend-mode: normal;
        text-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
        }
}
.steps-bar__item-dot {
  width: 32px;
  border-radius: 50%;
  height: 32px;
  z-index: 1;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  mix-blend-mode: normal;
  &::after{
    content: "";
    left: 50%;
    width: 100%;
    z-index: 0;
    position: absolute;
    height: 2px;
    background: var(--Grayscale-Line, #D3CFD0);
  }
  span{
     width: 32px;
  border-radius: 50%;
  height: 32px;
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFF;
  border: 1.5px dashed var(--Grayscale-Placehold, #9C9697);
  box-sizing: border-box;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  mix-blend-mode: normal; 
    &::after{
      content: "";
    width: 12px;
    height: 12px;
      border-radius: 50%;
      background: var(--Grayscale-Placehold, #D3CFD0);
    }
  }
}
.steps-bar__item-line {
height: 2px;
    background: var(--Grayscale-Line, #D3CFD0);
  flex-grow: 1;
  top: 8px;
  position: relative;
}

.step__btn-wrapper {
  display: flex;
  // max-width: 330px;
  gap: 12px;
  padding-top: 20px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
        @media only screen and (max-width: 720px) {
          padding-top: 28px;
            gap: 16px;
            flex-flow: row;
        }
}

.step {
  margin: 0 auto;

  // &.step--lg {
  //   max-width: 100%;
  // }
}
.btn {
  padding: 13px 35px 11px 35px;
  border: 1px solid #15329d;
  color: #15329d;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  margin-bottom: 15px;
  padding-right: 25px;
  padding-left: 25px;
  margin-left: auto;

  &.btn--negative {
    background: #15329d;
    color: white;
  }
  &.btn.btn--disabled {
    opacity: 1;
    filter: grayscale(100%);
    background: #fafafa;
    color: #b9b9b9;
    border-color: #cfcfcf;
  }
  &.btn--prev {
    margin-left: 0px;
  }
}

.total__summary {
  background: #fafafa;
  padding: 10px 15px;
  max-width: 300px;
  margin: 0 auto 24px;
}
.total__summary__total {
  color: black;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  font-size: 18px;
}
ul.total__summary__list {
  margin: 0px auto;
  display: flex;
  padding: 0px 0px 2px;
  justify-content: center;
  flex-flow: column;

  li {
    padding: 0px 0px;
  }
}
:deep(.multiple__payoptions) {
      max-width: 100%;
    margin: 0px auto 0px;
  .radio__label {
    flex-flow: wrap;
        @media only screen and (max-width: 720px) {
      flex-flow: column;
     
    }
  }
  .monthly-note {
    width: 100%;
    padding-bottom: 20px;
  }
}

.btn__blue {
display: flex;
min-height: 48px;
padding: 12px 20px;
justify-content: center;
align-items: center;
gap: 8px;
align-self: stretch;
  border-radius: 100px;
border-bottom: 4px solid #DA6B21;
background: var(--Primary-500, #FF961F);
color: var(--Grayscale-Ash, #160D10);
text-align: center;
font-family: "Blinker";
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 3px;
text-transform: uppercase;

max-width:100%;
  width: 100%;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
border-radius: 100px;
border-bottom: 2px solid #DA6B21;
background: var(--Primary-400, #FFB042);
  }
          @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
}
.btn__white {
border: 1px solid var(--Grayscale-Ash, #160D10);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  gap: 4px;
  max-width: 240px;
  border-radius: 6px;
  font-style: normal;
  width: 100%;
  font-weight: 500;
font-size: 16px;
line-height: 24px;
color: var(--Grayscale-Ash, #160D10);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
        background: rgba(255, 255, 255, 0.1);
  }
         @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
}

:deep(.personal__info) {
 
      .form-group.form-group--inline{
      margin-bottom: 16px;
    }
}

:deep(.personal__info) {
 
     select{
color: var(--Grayscale-Placehold, #9C9697);

/* Desktop/Text/Placeholder */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 300;
line-height: 24px; /* 171.429% */
    }
}


.donateion__list {
    max-width: 508px;
    margin: 0px auto 24px;
    position: relative;
    width: 100%;
}

.fee-info-container {
    max-width: 508px;
  min-height: 48px;
  padding: 10px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
    margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
    color: var(--Grayscale-Ash, #160D10);
  @media only screen and (max-width: 720px) {
    margin-bottom: 20px;

  }
}

.fee-toggle {
    display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  cursor: pointer;
  text-align: left;
}

.fee-toggle__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.fee-toggle__control {
  width: 54px;
  height: 25px;
  padding: 0 5px;
  border-radius: 999px;
  background: #9c9697;
  display: flex;
  align-items: center;
  flex: 0 0 54px;
  color: transparent;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  position: relative;
  transition: background-color 0.2s ease;
}

.fee-toggle__control::after {
  content: '';
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
  position: absolute;
  left: 3px;
  top: 3px;
  transition: transform 0.2s ease;
}

.fee-toggle__input:checked + .fee-toggle__control {
  background: #ff9700;
  color: #fff;
}

.fee-toggle__input:checked + .fee-toggle__control::after {
  transform: translateX(29px);
}

.fee-toggle__input:focus-visible + .fee-toggle__control {
  outline: 2px solid #231f20;
  outline-offset: 2px;
}

.fee-toggle__copy {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.fee-tooltip-trigger {
  position: relative;
  flex: 0 0 auto;
}

.fee-tooltip-button {
  padding: 2px 0;
  border: 0;
  background: transparent;
  color: #ff9700;
  font: inherit;
  font-size: 14px;
  font-style: italic;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
}

.fee-tooltip-button:focus-visible {
  outline: 2px solid #ff9700;
  outline-offset: 2px;
}

.fee-tooltip {
  width: min(315px, calc(100vw - 48px));
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgb(22 13 16 / 16%);
  position: absolute;
  right: -5px;
  bottom: calc(100% + 12px);
  z-index: 20;
  color: var(--Grayscale-Ash, #160D10);
  text-align: left;
}

.fee-tooltip::after {
  content: '';
  width: 12px;
  height: 12px;
  border-right: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  position: absolute;
  right: 12px;
  bottom: -7px;
  transform: rotate(45deg);
}

.fee-tooltip strong {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 18px;
}

.fee-tooltip p {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.fee-tooltip .amount,
.amount {
  display: inline-block;
  font-weight: 700;
}
.inline-block {
  display: inline-block;
}
.oudonation hr {
    background: none;
    box-shadow: none;
    height: 0;
    border: none;
    border-bottom: none;
}
h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: var(--Grayscale-Ash, #160D10);
    margin-top: 0px;
    margin-bottom: 12px;

}

.donatem__section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;
  align-items: flex-start;
      @media only screen and (max-width: 720px) {
     flex-flow: column;
             justify-content: center;
        align-items: center;
       gap: 0px;
    }
}
.donatem__right {
    max-width: 533px;
    position: relative;
        width: 100%;
}
.donatem__left {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border-width: 2px;
    padding: 24px;
    max-width: 532px;
    width: 100%;
      @media only screen and (max-width: 720px) {
            padding: 24px 24px 4px 24px;
      }
}

:deep(.dedicate__modals) {
  padding-bottom: 10px;
  max-width: 508px;
    margin: auto;
    width: 100%;
  label{
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    color: var(--Grayscale-Ash, #160D10);
    line-height: 18px;
    vertical-align: bottom;
  }
      @media only screen and (max-width: 720px) {
        .form-group{
          display: flex;
          align-items: center;
        }

    }

  textarea {
    min-height: 120px;
    padding: 10px 12px;
  }

input#note {
    width: 54px;
    height: 25px;
    padding: 0 5px;
    border-radius: 999px;
    background: #9c9697;
    flex: 0 0 54px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    &::before {
        content: "NO";
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.5px;
    }
    &::after {
        content: "";
        width: 19px;
        height: 19px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
        position: absolute;
        left: 3px;
        top: 3px;
        transition: transform 0.2s ease;
    }
    &:checked {
        background: #ff9700;
    }
    &:checked::before {
        content: "YES";
        right: auto;
        left: 7px;
    }
    &:checked::after {
        transform: translateX(29px);
    }
    &:focus-visible {
        outline: 2px solid #231f20;
        outline-offset: 2px;
    }
}

}

:deep(.dedicate__modals:has(#note:checked)),
:deep(.dedicate__modals:has(#inHonorOf:checked)) {
border-radius: 12px;
background: var(--Primary-50, #FFFAF5);
padding: 12px;

label{
  padding: 0px;
}
}

:deep(.dedicate__modals:has(#inHonorOf:checked)) {
  margin-bottom: 16px;

  .edit-recipient {
	color: var(--Grayscale-Ash, #160D10);
text-align: center;

/* Desktop/Text/Condensed/Action - Regular */
font-family: "Blinker";
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 3px;
text-transform: uppercase;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
}
// Drive the dedicate toggle from here because NcsyInHonorOf is an async component whose scoped-style HMR is unreliable
:deep(#inHonorOf) {
    width: 54px;
    height: 25px;
    padding: 0 5px;
    border-radius: 999px;
    background: #9c9697;
    flex: 0 0 54px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    &::before {
        content: "NO";
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.5px;
    }
    &::after {
        content: "";
        width: 19px;
        height: 19px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
        position: absolute;
        left: 3px;
        top: 3px;
        transition: transform 0.2s ease;
    }
    &:checked {
        background: #ff9700;
    }
    &:checked::before {
        content: "YES";
        right: auto;
        left: 7px;
    }
    &:checked::after {
        transform: translateX(29px);
    }
    &:focus-visible {
        outline: 2px solid #231f20;
        outline-offset: 2px;
    }
}
input#cover{
  display:none;
border: 1px solid var(--Grayscale-Line, #D3CFD0);
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
   content: "";
    position: absolute;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect y='0' width='16' height='16' rx='4' fill='%23FF961F'/%3E%3Cpath d='M12.4436 5.33325L6.33247 11.5555L3.55469 8.72719' stroke='%23FCFCFC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px 16px;
    top: 50%;
    left: 7px;
    transform: translate(-50%, -50%);
    width: 16px;
    height: 16px;
    }
}

// ::v-deep.honor__row {
//   label{
//       display: none !important;
//   }
    
// }
span.edit-recipient {

display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
gap: 4px;
width: 157px;
height: 36px;
border: 1px solid var(--Grayscale-Ash, #160D10);
border-radius: 6px;
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: var(--Grayscale-Ash, #160D10);
    text-align: center;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &:hover{
        background: rgba(255, 255, 255, 0.1);
      }
}

.honor__field{

}
.honor__row.form-group.form-group--inline {
    gap: 16px;
        @media only screen and (max-width: 720px) {
          gap: 12px;
          flex-flow: column;
          display: flex;
          margin-bottom: 16px;
    }
}

input[type="text"],
input[type="email"]
 select{
    padding: 12px;
    // height: 40px;
    // background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #4a4d50;

    &::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
    }
}
/* Placeholder styles for all browser prefixes */
input[type="text"]::placeholder,
input[type="email"]::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]::-webkit-input-placeholder,
input[type="email"]::-webkit-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]::-moz-placeholder,
input[type="email"]::-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]:-ms-input-placeholder,
input[type="email"]:-ms-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="text"]:-moz-placeholder,
input[type="email"]:-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}    

:deep(.personal__info){
input[type="email"],
input[type="text"],
input[type="tel"],
input[type="phone"],
input[type="number"],
textarea,
 select{
border-radius: 8px;
border: 1.2px solid var(--Grayscale-Input, #EBEBEB);
background: var(--Grayscale-Off-white, #FCFCFC);
box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06);
    display: flex;
height: 40px;
padding: 8px 12px;
align-items: center;
gap: 8px;
align-self: stretch;

option{       
  color:  #4a4d50 !important;
}    
    &::placeholder {
color: var(--Grayscale-Placehold, #9C9697);

/* Desktop/Text/Placeholder */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 300;
line-height: 24px; /* 171.429% */
    }
        &:focus {
    border-color: black;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
}
/* Placeholder styles for all browser prefixes */
input[type="text"]::placeholder,
input[type="email"]::placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]::-webkit-input-placeholder,
input[type="text"]::-webkit-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]::-moz-placeholder,
input[type="text"]::-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]:-ms-input-placeholder,
input[type="text"]:-ms-input-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}

input[type="email"]:-moz-placeholder,
input[type="text"]:-moz-placeholder {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #4a4d50;
}    

}

:deep(.personal__title){
    width: 100%
}
// ::v-deep .personal__country{
//     flex: 0 1 48% !important;
//     min-width: 48%;
//     max-width: 48%;
//     margin-left: 16px;
//     padding-right: 0px !important;
// }

.personal__firstrow{
  gap: 12px;
    justify-content: space-between;
}
.personal__statehide {
    opacity: 0.3 !important;
}
:deep(.personal__phone){
.vue-tel-input {
    // padding: 12px;
    height: 40px;
    background: white;
    // background: rgba(255, 255, 255, 0.1);
   border-radius: 8px;
border: 1.2px solid var(--Grayscale-Input, #EBEBEB);
background: var(--Grayscale-Off-white, #FCFCFC);
box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06);
color: var(--Grayscale-Label, #231F20);

/* Desktop/Text/Label */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 128.571% */
text-transform: capitalize;
    .dropdown {
        background: none;

       .dropdown-arrow {
          color: #4a4d50;
        }
    }

    input[type=tel]{
      border: none;
      background: none;
          &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
    }
              &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
}
    // flex: 0 1 30% !important;
    // min-width: 30%;
    // max-width: 30%;
    // display: flex;
    // padding-right: 0px !important;
    // align-items: center;
    // font-style: normal;
    // font-weight: 400;
    // font-size: 14px;
    // line-height: 20px;
    color: #4a4d50;
}

.directgift__section{

}

.directgift__option{
  
    display: flex;
    margin: 0px auto 12px;
    flex-direction: row;
    align-items: center;
    padding: 0px 16px 0px 0px;
    height: 48px;
    max-width: 395px;
    width: 100%;
    background: var(--Grayscale-Ash, #160D10);
    border: 2px solid #EBEBEB;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #080F16;

    input{
      position: absolute;
    opacity: 0;
    display: none;
    cursor: pointer;
        // width: 20px;
        // height: 20px;
        // border: 2px solid #1aa8d3;
    }

    label{
        position: relative;
        padding-left: 40px;
        user-select: none;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #4a4d50;
            width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    }
    input:checked ~ span {
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;
color: #595C5F;
    }

.radiobtn {
    position: absolute;
    left:10px;
    height: 20px;
    width: 20px;
    background-color: var(--Grayscale-Ash, #160D10);
    border: 2px solid #1aa8d3;
    border-radius: 50%;
    &:after{
    top: 3px;
    left: 3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #1aa8d3;
      content: "";
    position: absolute;
    display: none;
    }
} 
input:checked ~ .radiobtn {
    // background-color: #2196F3;
        border: 2px solid #1aa8d3;
    &:after {
    display: block;
  }
}   

}

.designation{
    max-width: 395px;
    margin: 0px auto 16px;
    width: 100%;
    padding-top: 14px;
}

.designation__infotext{
    max-width: 395px;
    margin: auto;
    width: 100%;
    font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
}
.payment__info {
    max-width: 775px;
    margin: auto;
    color: var(--Grayscale-Body, #494647);

/* Desktop/Text/Body 1 */
font-family: "Albert Sans";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 22px; /* 137.5% */
}

.form__subscribe{
    width: 100%;
margin: 0px auto 8px;
max-width: 446px;
display: flex;
align-items: center;
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 18px;
display: flex;
align-items: center;
color: var(--Grayscale-Ash, #160D10);
 label{
    font-weight: 500;
    font-size: 14px;
    padding: 0px;
    color: var(--Grayscale-Ash, #160D10);
    line-height: 18px;
    flex: 1;
    vertical-align: bottom;
  }

input {
   border: 1.5px solid #F7F7F7;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
  content: "";
  position: absolute;
  background-color: #FDFDFD;
background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.4446 1.33331L4.33344 7.55554L1.55566 4.72725' stroke='%23FF961F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 9px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 2px;
    }
}
}

  button.ougiving__btn{
display: flex;
min-height: 48px;
padding: 12px 20px;
justify-content: center;
align-items: center;
gap: 8px;
align-self: stretch;
  border-radius: 100px;
border-bottom: 4px solid #DA6B21;
background: var(--Primary-500, #FF961F);
color: var(--Grayscale-Ash, #160D10);
text-align: center;
font-family: "Blinker";
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 3px;
text-transform: uppercase;
border: none;
max-width:100%;
  width: 100%;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover{
border-radius: 100px;
border-bottom: 2px solid #DA6B21;
background: var(--Primary-400, #FFB042);
  }
          @media only screen and (max-width: 720px) {
padding: 10px;
font-size: 14px;
line-height: 20px;
          }
}
  .btnpayment__text{
      display: flex;
      gap: 4px;
      text-align: center;
      // width: 100%;
      text-transform: uppercase;

      flex-direction: row;
      justify-content: center;
      align-items: center;
  }

.personal__firstrow{
  .dform__col{
    padding: 0px !important;
    position: relative;
      min-width: 100%;
      max-width: 100%;
    flex: 0 1 100%;
        @media only screen and (min-width: 720px) {
      min-width: calc((100% - 32px) / 3);
      max-width: calc((100% - 32px) / 3);
    flex: 0 1 calc((100% - 32px) / 3);
        }
  }
}

.dform__rowdouble{
  gap: 16px;
  .dform__col{
    padding: 0px !important;
    position: relative;
      min-width: 100%;
      max-width: 100%;
    flex: 0 1 100%;
            @media only screen and (min-width: 720px) {
      min-width: calc((100% - 16px) / 2);
      max-width: calc((100% - 16px) / 2);
    flex: 0 1 calc((100% - 16px) / 2);
            }
  }
}

:deep(.dform__col){

  .error-label{
    margin-top: 1px;
  }
}

.donation__vector{
  position: absolute;
  bottom: 0;
  right:32px;
  display: none;
      @media only screen and (min-width: 720px) {
       display: flex;
    }
}
.doantion__backlink{
  position: absolute;
  top: 32px;
  left:32px;
  display: flex;
  cursor: pointer;

      @media only screen and (max-width: 720px) {
  top: 13px;
  left:20px;
      }
}

.gift__setup{
  h2{
    margin-bottom: 12px;
  }
}

:deep(.payment__cc){
  max-width: 100%;
  margin: 0px auto;

  .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
    background: #FF961F;
      border: none;
  }
}
.steps-bar__svg{
      display: none;

   @media only screen and (max-width: 720px) {
   }
}

.dedicate__mobile__info{
   @media only screen and (max-width: 720px) {
    display: flex;
    flex-flow: column-reverse;
   }
}

h2.h2__mixed{
  color: white;
    margin-bottom: 20px;
    text-align: center;
        font-weight: 700;
    font-size: 24px;
        line-height: 32px;
   @media only screen and (min-width: 720px) {
        font-size: 40px;
        line-height: 52px;
   }
   span {
    text-transform: capitalize;
    color: #9ABBFF;
  }
}

:deep(.error-label){
    padding-left: 6px;
    font-size: 11px;
    color: red;
    font-weight: 400;
    font-style: normal;
    width: 100%;
    display: block;
    text-align: left;
    position: absolute;
    &::before {
    content: "*";
    color: red;
    left: 0px;
    position: absolute;
  }
}

:deep(.phonec__consent){
  margin: -2px auto 18px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--Grayscale-Ash, #160D10);
  label.label__consent{
    text-align: left;
     font-style: normal;
  font-weight: 400;
      padding-top: 1px;
    font-size: 12px !important;
    line-height: 16px !important;
  color: var(--Grayscale-Ash, #160D10); 
  }
  a{

    font-style: normal;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 16px !important;

  }

  input#consent {
border-radius: 4px;
border: 1px solid var(--Grayscale-Placehold, #9C9697);
    width: 16px;
    height: 16px;
    border-radius: 3px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    position: relative;
    &:checked::after {
// content: "✓";


    content: "";
    position: absolute;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect y='0' width='16' height='16' rx='4' fill='%23FF961F'/%3E%3Cpath d='M12.4436 5.33325L6.33247 11.5555L3.55469 8.72719' stroke='%23FCFCFC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px 16px;
    top: 50%;
    left: 7px;
    transform: translate(-50%, -50%);
    width: 16px;
    height: 16px;
    }
}
}

.checktext strong {
    padding-bottom: 2px;
    display: block;
}
.checktext p {
    font-size: 15px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 7px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: white;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}


label.label__tight{
    color: var(--Grayscale-Ash, #160D10);
    font-family: in"Albert Sans";
    font-size: 14px;
    font-style: normal;
    text-align: left;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    text-transform: capitalize;
    padding: 0px 0px 8px;
    display: block;
}

.designations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 16px;
  max-width: 480px;
  margin: 0px auto 0;

  @media only screen and (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin: 16px auto 0;
  }
}

.designations-grid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media only screen and (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.designations__collect {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  max-width: 480px;
  margin: 0px auto 0;

  > .designations-grid {
    max-width: none;
    margin: 0;
  }

  > .designations-grid:first-child {
    grid-column: 1 / span 3;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  > .designations-grid:last-child {
    grid-column: 4 / span 1;
    grid-template-columns: 1fr;
  }

  > .designations-grid:last-child .designation-card {
    height: 100%;
    justify-content: space-between;
    min-height: 100%;
  }

  @media only screen and (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 12px;

    > .designations-grid:first-child {
      grid-template-columns: repeat(2, 1fr);
    }

    > .designations-grid:last-child .designation-card {
      min-height: 92px;
    }
  }
}

.designations__collect--three {
  display: block;
}

.designations__collect--three > .designations-grid {
  max-width: 480px;
  margin: 0 auto;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media only screen and (max-width: 720px) {
  .designations__collect--three > .designations-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.designation-card {
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--Grayscale-Ash, #160D10);
text-align: center;
font-family: "Albert Sans";
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 100% */
  align-items: center;
  height: 92px;
  justify-content: flex-end;
  gap: 7px;
  padding: 8px 8px 10px 8px;
  border: 0.8px solid #E5E7EB;
  border-radius: 12px;
  background: #FFF;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  input[type="radio"] {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-sizing: border-box;
    border: 1px solid var(--Grayscale-Line, #D3CFD0);
    border-radius: 50%;
    background: white;

    &:checked {
      border: 0.5px solid #933A16;
      background: #FCFCFC;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 10px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: #FF961F;
      }
    }

    &:hover {
    border-radius: 12px;
    border: 0.8px solid var(--Grayscale-Placehold, #9C9697);
    background: #F5F5F5;
    }
  }

  &:hover {
    border-radius: 12px;
    border: 0.8px solid var(--Grayscale-Placehold, #9C9697);
    background: #F5F5F5;
  }

  &:has(input[type="radio"]:checked) {
    border-radius: 12px;
    border: 0.8px solid var(--Primary-300, #FFC362);
    background: var(--Primary-100, #FFF8EB);
  }

  &.designation-card--selected {
    border-radius: 12px;
    border: 0.8px solid var(--Grayscale-Placehold, #9C9697);
    background: #F5F5F5;
  }
}

.designation-card__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.designation-card__icon {


}

.designation-card__label {
  font-family: "Albert Sans";
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  color: var(--Grayscale-Ash, #160D10);
  text-transform: capitalize;

  @media only screen and (max-width: 720px) {
    font-size: 11px;
    line-height: 13px;
  }
}

* {
  box-sizing: border-box;
}

.designgen{
      justify-content: space-between;
    height: 100%;
}
:deep(.ncsydeig__select){

  position: relative;
  margin: 10px 0px 24px;
  select{
    display: flex;
height: 40px;
padding: 8px 12px 8px 38px;
align-items: center;
gap: 8px;
align-self: stretch;
    border-radius: 8px;
border: 1.2px solid var(--Grayscale-Input, #EBEBEB);
background: var(--Grayscale-Off-white, #FCFCFC);
box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06);
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 300;
line-height: 24px; /* 171.429% */
  }

}

.ncsydeig__icon{
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 1;
}


.steps__infheader{
  display: flex;
align-items: center;
justify-content: space-between;
gap: 8px;
margin-bottom: 22px;

h2{
  margin: 0px;
}
  .btn__back{
    cursor: pointer;
width: 40px;
min-height: 48px;
justify-content: center;
align-items: center;
border-radius: 100px;
display: flex;
gap: 8px;

    &:hover{

background: rgba(13, 18, 22, 0.06);
  }
  }
}

.personal__info{
  label{
    color: var(--Grayscale-Label, #231F20);
    text-align: left;
    /* Desktop/Text/Label */
    font-family: "Albert Sans";
    font-size: 14px;
    font-style: normal;
    padding: 0px 0px 4px;
    display:block;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    text-transform: capitalize;
  }
}

a.contentlink{
  margin: 8px auto 0px;
  color: var(--Grayscale-Placehold, #9C9697);
text-align: center;
text-decoration: none;
/* Desktop/Text/Link - Large */
font-family: "Albert Sans";
display: flex;
align-items: center;
justify-content: center;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 150% */

&:hover{
  text-decoration: underline;
}
}

.required{
  color: var(--Grayscale-Label, #231F20);
}
.dedicate__mobile__info {
    border-top: 1px solid #d3cfd080;
    padding-top: 24px;
    margin-top: 24px;
}
</style>
